import { Component, OnInit, NgZone, AfterViewChecked, ChangeDetectionStrategy } from '@angular/core';
import { bmxurl, getAccess, extraAvailableOnDate, selectedResources, selectableResourceIds } from 'src/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AvailableTimes, AvailabilityReq, Payment, Customer } from '../../PackageClasses';
import { customer } from 'src/types/customer';
import { booking } from 'src/types/booking';
import { booking_returndata } from 'src/types/booking_returndata';
import { MessageService } from 'primeng/api';
import { cExtra } from 'src/types/extra';
import { cPackageExtra } from 'src/types/packageExtra';
import { cResource, resource } from 'src/types/resource';
import { v4 as uuidv4  } from 'uuid';
import { BusyService } from '../_services/busy.service';
import { admission } from 'src/types/admission';
import { cBookingfee } from 'src/types/bookingfee';
import { paymenttypes_returndata } from 'src/types/paymenttypes_returndata';
import { bookingsummary, cBookingsummary } from 'src/types/bookingsummary';
import { DomSanitizer } from '@angular/platform-browser';
import { packagegroups_returndata } from 'src/types/packagegroup_returndata';
import { cPackagegroups } from 'src/types/packagegroups';
import { cDiscountvalidate, cOpenDiscountvalidate } from 'src/types/discountvailidate';
import { conf_returndata } from 'src/types/conf_returndata';
import { users_returndata } from 'src/types/user_returndata';
import { birthdayanswers, questionanswers } from 'src/types/questionanswers';
import { bookingquestionitem } from 'src/types/bookingquestion';
import { BehaviorSubject, Subscription, timer } from 'rxjs';
import { cVouchervalidate } from 'src/types/vouchervalidate';
import { venueclosings_returndata } from 'src/types/venueclosings_returndata';
import { venuesettings_returndata } from 'src/types/venuesettings_returndata';
import { GlobalService } from '../_services/global.service';
import { availabletimes_returndata } from 'src/types/availabletimes_returndata';
import { packageabupgrade, packageupgrade } from 'src/types/packageupgrade';
import { map, takeWhile, throwIfEmpty } from 'rxjs/operators';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { membership } from 'src/types/memberships';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';
import { BookingPrefillService, bookingprefill } from '../_services/booking-prefill.service';

@Component({
  selector: 'app-makeabooking',
  templateUrl: './makeabooking.component.html',
  styleUrls: ['./makeabooking.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MakeabookingComponent implements OnInit, AfterViewChecked {

  //#region  Variables
  id: string;
  BookingComplete: boolean = false;
  packages: any[] = [];
  packages1: any[] = [];
  SelectedPackage: any;
  SelectedResources: any[] = []
  SelectedDate: Date;
  startTimes: any;
  startTimesFiltered: any;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateCustomer: any;
  PaymentTypes: any = [];
  selectedPayment: any;
  packageExtras: cPackageExtra[];
  extraSingleDates: { [extraId: string]: string } = {};
  extraVariableValues: { [extraId: string]: boolean } = {};
  allVariableValuesValid: boolean = true;
  selectedPackageExtras: cExtra[];

  BookingDateAndTime: string = "";
  BookingPackage: string = "";
  BookingAdmissions: string = "";
  BookingAddress: string = "";
  BookingEmail: string = "";
  BookingMobile: string = "";
  BookingValue: string = "";
  Itinerary: string = "";
  bookingExtras: string = "";

  paymentValueValid: boolean = true;
  paymentTypeValid: boolean = true;
  paymentValueExceededValid: boolean = true;
  paymentDepositValid: boolean = true;
  validPaymentAmount: number = 0;

  AllValid: boolean =true;
  CustomerAllValid: boolean =true;

  PackageAdmissions: admission[];
  SelectedAdmissions: admission[];

  PackageHeader: string = "Select a Package";
  CalendarHeader: string = "Select a Date";
  AdmissionHeader: string = "Select your Admissions";
  TimeHeader: string = "Select a Time";
  CustomerHeader: string = "Create a Customer";
  PaymentHeader: string = "Add a Payment";
  ExtrasHeader: string = "Select Extras";
  SelResourceHeader: string = "Please Select";

  packageSelected: Boolean;
  admissionsSelected: Boolean;
  dateSelected: Boolean;
  timeSelected: Boolean;
  customerSelected:Boolean;
  paymentSelected:Boolean;
  extraSelected: Boolean;
  notesSelected: Boolean;
  partyroomsSelected: Boolean;
  bookingQuestionsSelected: Boolean;
  upgradeSelected: Boolean;

  packageActive: Boolean;
  admissionsActive: Boolean;
  dateActive: Boolean;
  timeActive: Boolean;
  customerActive:Boolean;
  paymentActive:Boolean;
  extraActive: Boolean;
  notesActive: Boolean;
  partyroomsActive: Boolean;
  partyroomsVisible: Boolean;
  bookingQuestionsActive: Boolean;
  upgradeActive: Boolean;

  //Customer
  firstName: string = "";
  lastName: string = "";
  address1: string = "";
  address2: string = "";
  town: string = "";
  postCode: string = "";
  email: string = "";
  mobile: string = "";
  dob: Date = new Date(1900, 1, 1);

  firstNameValid: boolean = true;
  lastNameValid: boolean = true;
  Address1Valid: boolean = true;
  TownValid: boolean = true;
  PostCodeValid: boolean = true;
  EmailValid: boolean = true;
  MobileValid: boolean = true;
  NewBooking = {} as booking;

  EmailFormatValid: boolean = true;
  MobileFormatValid: boolean = true;

  stateOptions: any[];
  stateOptionsMin: any[];
  statePayOptions: any[];

  ProvideMinimalPersonalData: string = "LIMITED";

  BookingResponse: any;

  //payment
  paymentAmount: number;
  maxPayment: number;

  searchCriteria: string;
  customersResult: any;

  disgnosticsMode: boolean = true;
  ShowCustomerDetails: boolean = false;

  makeABookingHeader: string = "Make a Booking"

  UpgradeHeader: string = "Select an Upgrade";
  showUpgrade: boolean = false;

  OptionalUpgradeHeader: string = "Select an Add On";
  showOptionalUpgrade: boolean = false;

  notes: string;

  SelectedSeletableResource: any[] = [];
  SelectedSeletableResourceBool: boolean[] = [];

  customerSelectedResources: any[] = [];
  includesComplexResources: boolean = false;
  includesOptionalResources: boolean = false;

  systemChoosesAllResources: boolean = true;

  validselection: boolean[] = [];

  totalAdmissions: number = 0;

  maxadmissions: number = 0;
  minadmissions: number = 0;

  totalAdmissionInRange: boolean;
  PackageHasExtras: boolean;

  MinimumValidPayment:number = 0;
  MustIncludePass: boolean = true;

  httpResponse: any;
  BookingFee: cBookingfee;
  BookingSummary: bookingsummary;
  packageGroups: any[];

  checked: any[] = [];
  popular: any;

  showDiscount: boolean = false;
  discountCode: string = "";

  BookingFeeAdddedOn: number = 0;
  DiscountTakenOff: number = 0;

  showPrintConfirmations: boolean = false;
  confHTML: string = "";

  TotalExtras: number = 0;
  minimumDiscount: number = 0;

  BookingPayments: Payment[] = [];
  totalPayments: number;

  terminalHubConnection: HubConnection | null = null;
  awaitingTerminalPayment: boolean = false;
  showPaymentFailedDialog: boolean = false;
  paymentFailedMessage: string = '';
  showTerminalBusyDialog: boolean = false;
  private pendingTerminalPayload: any = null;
  private pendingTerminalRetry: (() => void) | null = null;
  private terminalPaymentResolved: boolean = false;
  private terminalPollingIntervalId: ReturnType<typeof setInterval> | null = null;
  private pendingScrollToFirstTime: boolean = false;

  showDeferReason: boolean = false;
  deferNotes: string = "";
  AvailabilityReq = {} as AvailabilityReq;
  AvailabilityReq2 = {} as AvailabilityReq;
  AvailabilityReq3 = {} as AvailabilityReq;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  stateOptionAllergy: any[];

  mustanswerallergies: boolean[] = [];
  mustanswerage: boolean[] = [];
  mustanswerbirthdays: boolean[] = [];
  mustanswernumber: boolean[] = [];
  mustanswerfreetext: boolean[] = [];
  mustanswermultichoicesingleanswer: boolean[] = [];
  mustanswermultichoicemultianswer: boolean[] = [];
  mustanswerdate: boolean[] = [];

  questionAnswers: questionanswers[] = [];
  questionAnswer: questionanswers;

  bookingFreeTextAnswer: string = "";
  bookingallergyanswer: string = "";
  bookingnumberanswer: number = 0;
  bookingdateanswer: Date = null;
  allergyAnswer:boolean[] = [];
  bookingmultichoicesingleanswer: bookingquestionitem = null;
  bookingmultichoicemultianswer: bookingquestionitem[] = [];
  showVoucher: boolean = false;
  voucherCode: string = "";
  voucherpin: string = "";

  timetobetried: string = "";

  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  allergyOptions: any[] = [{ name: 'Yes', value: true }, { name: 'No', value: false}];

  CurrentDate = new Date();//new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0,0,0,0);

  VoucherComplete: boolean = false;

  SummaryItinerary: boolean = false;

  allQuestionsValid: boolean = true;
  linkedAdmissionMessageShown: boolean = false;
  showWarning: boolean = false;
  WarningMessage: string = "";
  totalDiscount: number = 0;

  paymentButtonLocked: boolean = false;

  stateOptionOpenDiscount: any[];
  stateGenderOptions: any[];

  openDiscount: boolean = false;

  chosenDiscountAmount: number = 0;

  showVCWarning: boolean = false;
  VCWarningMessage: string = "";

  venueClosings: any[] = [];

  caldays: any[] = [];
  calmonths: any[] = [];
  calyears: any[] = [];

  DOBDay: any[] = [];
  DOBMonth: any[] = [];
  DOBYear: any[] = [];

  DOBIsValid: boolean = true;
  dobage: any[] = [];
  private ageOptionCache: Map<string, any[]> = new Map<string, any[]>();


  oldDepositValue: number = 0;

  UseIntervalAvailability: boolean = false;

  NewAllowedMin: number = 0;

  availablePackageUpgrades: packageupgrade[] = [];
  availablePackageOptionalUpgrades: packageabupgrade[] = [];

  upgradeavaibilitydone: boolean[] = [false,false,false];
  showTheUpgradeScreen: boolean[] = [false,false,false];

  optioanlUpgradeavaibilitydone: boolean[] = [false,false,false];
  showTheOptionalUpgradeScreen: boolean[] = [false,false,false];
  

  upgradesComplete: boolean = false;
  showUpgradesScreen: boolean = false;

  showOptionalUpgradesScreen: boolean = false;
  optionalUpgradesComplete: boolean = false;

  UpgradeForTime: any;
  MembershipID: string;

  showTimer: boolean = false;

  ActualTimeRemaining: number = 0;
  timeoutTime: number = 30;

  PBWStartTime: Date;

  BookingTimeElasped: boolean = false;

  timeRemaining$: any;
  timerSubscription: Subscription;

  MembershipPIN: string = "";
  customerMemberships: membership[] = [];

  optionalUpgradeSelected: Boolean = false;
  optionalUpgradeActive: Boolean = false;
  globalTimeSlot: AvailableTimes;

  qbook: string = "";

  // Bound method for the pipe to prevent continuous function calls
  getOptionalUpgradeQuantities = (pu: any) => {
    let NumberList: any[] = [];
    let Numbers = {}
    for(var i = 0; i <= pu.quantityremaining; i++)
    {
      Numbers = { "name": i.toString(), value: i };
      NumberList.push(Numbers);
    }
    return NumberList;
  }
  NoAvailabilityMessage: string = "Unfortunately we are fully booked on this date and time for your group size - please try another date";

  //#endregion

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private messageService: MessageService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private busyService: BusyService, private globalService: GlobalService,
    private auth: AuthService, private ngZone: NgZone,
    private bookingPrefillService: BookingPrefillService) {
      this.stateOptions = [{ label: 'Use full personal details', value: "FULL" }, { label: 'Use limited personal details', value: "LIMITED"}, { label: 'Walk In', value: "WALKIN" }]; 
      this.stateOptionsMin = [{ label: 'Use full personal details', value: "FULL" }, { label: 'Use limited personal details', value: "LIMITED"}];    
      this.stateOptionAllergy = [{ label: 'Yes', value: true }, { label: 'No', value: false}];  
      this.stateOptionOpenDiscount = [{ label: 'Enter Discount Value', value: true }, { label: 'Enter Discount Code', value: false}]; 
      this.stateGenderOptions =  [{ label: 'Rather not say', value: 'NOT STATED' }, { label: 'Male', value: 'MALE'}, {label: 'Female', value: 'FEMALE'}]; 
      
      this.dobage = [
        {name:'0 to 3 months', value:'0 to 3 months'},
        {name:'4 to 6 months', value:'4 to 6 months'},
        {name:'6 to 12 months', value:'6 to 12 months'},
        {name:'1', value:'1'},
        {name:'2', value:'2'},
        {name:'3', value:'3'},
        {name:'4', value:'4'},
        {name:'5', value:'5'},
        {name:'6', value:'6'},
        {name:'7', value:'7'},
        {name:'8', value:'8'},
        {name:'9', value:'9'},
        {name:'10', value:'10'},
        {name:'11', value:'11'},
        {name:'12', value:'12'},
        {name:'13', value:'13'},
        {name:'14', value:'14'},
        {name:'15', value:'15'},
        {name:'16', value:'16'},
        {name:'17', value:'17'},
        {name:'18', value:'18'},
        {name:'Over 18', value:'Over 18'}
      ];

      this.caldays =  [
        {name: '01', value:'01'},
        {name: '02', value:'02'},
        {name: '03', value:'03'},
        {name: '04', value:'04'},
        {name: '05', value:'05'},
        {name: '06', value:'06'},
        {name: '07', value:'07'},
        {name: '08', value:'08'},
        {name: '09', value:'09'},
        {name: '10', value:'10'},
        {name: '11', value:'11'},
        {name: '12', value:'12'},
        {name: '13', value:'13'},
        {name: '14', value:'14'},
        {name: '15', value:'15'},
        {name: '16', value:'16'},
        {name: '17', value:'17'},
        {name: '18', value:'18'},
        {name: '19', value:'19'},
        {name: '20', value:'20'},
        {name: '21', value:'21'},
        {name: '22', value:'22'},
        {name: '23', value:'23'},
        {name: '24', value:'24'},
        {name: '25', value:'25'},
        {name: '26', value:'26'},
        {name: '27', value:'27'},
        {name: '28', value:'28'},
        {name: '29', value:'29'},
        {name: '30', value:'30'},
        {name: '31', value:'31'}
      ];
          
      this.calmonths = [
        {name: '01', value:'01'},
        {name: '02', value:'02'},
        {name: '03', value:'03'},
        {name: '04', value:'04'},
        {name: '05', value:'05'},
        {name: '06', value:'06'},
        {name: '07', value:'07'},
        {name: '08', value:'08'},
        {name: '09', value:'09'},
        {name: '10', value:'10'},
        {name: '11', value:'11'},
        {name: '12', value:'12'}
      ];
      
      for(let i = 2050; i > 1920; i--)
        {
          let thisYear = new Date().getFullYear();
          if(i <= thisYear)
          {
            this.calyears.push({name: i.toString(), value: i.toString()});
          }
        }

      this.SummaryItinerary = localStorage.getItem("SummaryItineraryVenue") == "true" ? true : false;

      this.globalService.upgradesComplete$.subscribe((value) => {
        this.upgradesComplete = value;
      });

      this.globalService.upgradeScreen$.subscribe((value) => {
        this.showUpgradesScreen = value;
      });

      this.globalService.optionalUpgradesComplete$.subscribe((value) => {
        this.optionalUpgradesComplete = value;
      });

      this.globalService.optionalUpgradeScreen$.subscribe((value) => {
        this.showOptionalUpgradesScreen = value;
      });
  
  }

  restartTimer(_inTime: any){
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.PBWStartTime = new Date();
    this.BookingTimeElasped = false;

    this.timeRemaining$ = timer(0, 1000).pipe(
      map(n => (this.timeoutTime - n) * 1000),
      takeWhile(n => n >= 0)
    );

    this.timerSubscription = this.timeRemaining$.subscribe(
      () => this.CheckValue(),
      () => null,
      () => {
          this.BookingTimeElasped = true;
      }
    );
  }

  //html2canvas(document.getElementById('invoice-panel'), { letterRendering: 1, allowTaint: true, onrendered: function (canvas) {                 } });

  generatePDF() {
    const data = document.getElementById('confToPrint');

    html2canvas(data).then(canvas => {
      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      const heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4'); 

      let position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
      pdf.save('Confimation-' + this.NewBooking.bookingIdHR + new Date().toISOString() + '.pdf');
    });

  }

  CheckValue()
  {
    let StartingTimeAmount = this.timeoutTime * 1000
    let NowTime = new Date().getTime();
    this.ActualTimeRemaining = this.PBWStartTime.getTime() - NowTime + StartingTimeAmount;

    if (this.ActualTimeRemaining <= 0) 
    {
      this.BookingTimeElasped = true;
      if(this.NewBooking.bookingId != null)
      {
        let abandonBooking: any = {
          bookingid: this.NewBooking.bookingId,
          jwt: null
        }
        //Booking Exists, abandon it
        this.http.post(bmxurl + "abandonbooking/", abandonBooking).subscribe(response => {
          this.NewBooking = (response as booking_returndata).data;

        }, error => {
          this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to abandon booking.'});
        });
      }
    }
  }

  WarningContinue(){

    this.showWarning = false;
  }

  admitall(){
    this.http.get(bmxurl + "BookingCheckin/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Admitted', detail:'All customers admitted for this booking.'});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Admitted', detail: 'An error occurred admitting all customers for this booking'});
    })
  }

  getToManageWaivers(bookingId)
  {
    this.router.navigate(['/managewaivers', bookingId], {
      queryParams: { returnDate: this.dateSelected }
    });
  }

  admitAndReturn()
  {
    if (this.SelectedPackage?.waiverrequired) {
      this.getToManageWaivers(this.NewBooking.bookingId);
      return;
    }

    this.http.get(bmxurl + "BookingCheckin/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded) {
        this.messageService.add({severity:'success', summary:'Admitted', detail:'All customers admitted for this booking.'});
        const today = new Date();
        const dateStr = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
        this.router.navigateByUrl('/ataglance/' + dateStr);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Admitted', detail: 'An error occurred admitting all customers for this booking'});
    });
  }

  //Birthday and register both ask for a list of people and keep them in the same place, so the
  //grid, the validation and the add and delete buttons are shared between them.
  isPersonListQuestion(questiontype: string): boolean {
    return questiontype == "BIRTHDAY" || questiontype == "REGISTER";
  }

  //Where an entry in the age list sits, in months. The list opens with three month bands and
  //closes with Over 18, so a plain number is only part of it.
  private ageInMonths(value: string): number {
    if(value == "0 to 3 months") return 0;
    if(value == "4 to 6 months") return 4;
    if(value == "6 to 12 months") return 6;
    if(value == "Over 18") return 228;

    const years = Number(value);
    return isNaN(years) ? 0 : years * 12;
  }

  //A birthday or register question can be set up for a range of ages, held in months. The list
  //is filtered down to that range and kept, so the dropdown is handed the same array on every
  //change detection run rather than a freshly built one.
  ageOptionsFor(question: any): any[] {
    const min = question.minage == null ? 0 : question.minage;
    const max = question.maxage == null ? 0 : question.maxage;

    if(min == 0 && max == 0)
      return this.dobage;

    const key = min + "-" + max;

    if(!this.ageOptionCache.has(key))
    {
      this.ageOptionCache.set(key, this.dobage.filter(option => {
        const months = this.ageInMonths(option.value);
        return months >= min && (max == 0 || months <= max);
      }));
    }

    return this.ageOptionCache.get(key);
  }

  //Each birthday question keeps its own list of people, so adding a row to one question leaves
  //the others alone.
  addBirthdayRow(question: any){

    if(question.answers.birthdayanswers == null)
      question.answers.birthdayanswers = [];

    question.answers.birthdayanswers.push({
      index: question.answers.birthdayanswers.length,
      id: uuidv4(),
      name: "",
      age: "",
      birthdate: "",
      gender: "NOT STATED",
      interests: "",
      showage: question.showage,
      showdob: question.showdob,
      showgender: question.showgender,
      showinterests: question.showinterests,
      dobday: "",
      dobmonth: "",
      dobyear: ""
    });
  }

  //Splicing inside a forEach skips the row after the one taken out, so the row is found first
  //and then removed once.
  deleteBirthdayRow(question: any, inId){

    if(question.answers.birthdayanswers == null)
      return;

    const index = question.answers.birthdayanswers.findIndex(element => element.id == inId);

    if(index > -1)
      question.answers.birthdayanswers.splice(index, 1);
  }

  sendPaymentLink(){

    this.NewBooking.payments = null;
    this.NewBooking.inProgress = false;
    this.NewBooking.awaitingpayment = true;

    this.http.post<any>(bmxurl + "/Payment", this.NewBooking).subscribe(response => {
     this.BookingResponse = response
     this.BookingDateAndTime = new Date(this.BookingResponse.data.startTime).getUTCDate().toString().padStart(2, '0') + "/" + new Date(this.BookingResponse.data.startTime).getUTCMonth().toString().padStart(2, '0') + "/" + new Date(this.BookingResponse.data.startTime).getUTCFullYear() + " " + new Date(this.BookingResponse.data.startTime).getUTCHours().toString().padStart(2, '0') + ":" + new Date(this.BookingResponse.data.startTime).getUTCMinutes().toString().padStart(2, '0');

     this.BookingPackage = this.BookingResponse.data.packageName;
    
     this.http.get<any>(bmxurl + "sendpaymentlink/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.httpResponse = response;

      if(!this.httpResponse.succeeded)
      {
        this.messageService.add({severity:'error', summary:'Failure', detail: this.httpResponse.messages[0]});
      }
      else
      {
        if(this.BookingResponse.data.payments != null)
        {
          if(this.BookingResponse.data.payments.length > 0)
          {
            this.messageService.add({severity:'success', summary:'Success', detail: 'Payment link sent'});
          }
          else
          {
            this.messageService.add({severity:'success', summary:'Success', detail: 'Payment link sent, the customer will have 4 hours to respond to this link otherwise the booking will be cancelled. Cancelled bookings cannot be paid.'});
          }
        }
        else
        {
          this.messageService.add({severity:'success', summary:'Success', detail: 'Payment link sent, the customer will have 4 hours to respond to this link otherwise the booking will be cancelled. Cancelled bookings cannot be paid.'});
        }
        this.DoSummary(this.BookingResponse.data);
      }

    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the Email'});
    })

    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to defer payment'});
    })

  }

  doneBookingQuestions(){
    let AllValid = true;

    this.SelectedPackage.questionnaire.bookingquestions.forEach(question => {
      if(question.questiontype == "ALLERGY")
      {
        if(question.answers.allergyanswer.allergypresent == true)
        {
          if(question.answers.allergyanswer.allergytext == "" && question.mandatory)
          {
            AllValid = false;
            this.mustanswerallergies[question.listorder] = false;
          }
          else
          {
            this.mustanswerallergies[question.listorder] = true;
          }
        }
        else
        {
          this.mustanswerallergies[question.listorder] = true;
        }
      }
      else if(question.questiontype == "AGE")
      {
        if(question.answers.numberanswer == null && question.mandatory)
        {
          AllValid = false;
          this.mustanswerage[question.listorder] = false;
        }
        else
        {
          this.mustanswerage[question.listorder] = true;
        }
      }
      else if(this.isPersonListQuestion(question.questiontype))
      {
        this.mustanswerbirthdays[question.listorder] = true;

        (question.answers.birthdayanswers ?? []).forEach(person => {

          if(question.showdob)
            person.birthdate = person.dobday + "/" + person.dobmonth + "/" + person.dobyear;
          else
            person.birthdate = "";

          if(question.mandatory)
          {
            //Every field the question was set up to ask for has to be answered - the extra field
            //on a register included. Read off the question rather than the saved row, so a field
            //switched on after an answer was saved is still enforced; the grid decides what to
            //show on the same basis.
            let missing = person.name == "" || person.name == null
              || ((person.age == "" || person.age == null) && question.showage)
              || ((person.birthdate == "" || person.birthdate == null) && question.showdob)
              || ((person.interests == "" || person.interests == null) && question.showinterests);

            if(missing)
            {
              AllValid = false;
              this.mustanswerbirthdays[question.listorder] = false;
            }
          }
        });
      }
      else if(question.questiontype == "NUMBER")
      {
        if(question.answers.numberanswer == null && question.mandatory)
        {
          AllValid = false;
          this.mustanswernumber[question.listorder] = false
        }
        else
        {
          this.mustanswernumber[question.listorder] = true
        }
      }
      else if(question.questiontype == "FREETEXT")
      {
        if((question.answers.freetextanswer == null || question.answers.freetextanswer == "") && question.mandatory)
        {
          AllValid = false;
          this.mustanswerfreetext[question.listorder] = false;
        }
        else
        {
          this.mustanswerfreetext[question.listorder] = true;
        }
      }
      else if(question.questiontype == "DATE")
      {
        if(question.answers.dateanswer == null && question.mandatory)
        {
          AllValid = false;
          this.mustanswerdate[question.listorder] = false;
        }
        else
        {
          this.mustanswerdate[question.listorder] = true;
        }
      }
      else if(question.questiontype == "MULTICHOICESINGLE")
      {
        if(question.answers.multichoicesingleanswer.id == null && question.mandatory)
        {
          AllValid = false;
          this.mustanswermultichoicesingleanswer[question.listorder] = false;
        }
        else
        {
          this.mustanswermultichoicesingleanswer[question.listorder] = true;
        }

      }
      else if(question.questiontype == "MULTICHOICEMULTIPLE")
      {
        if(question.answers.multichoicemultianswer.length == 0 && question.mandatory)
        {
          AllValid = false;
          this.mustanswermultichoicemultianswer[question.listorder] = false;
        }
        else
        {
          this.mustanswermultichoicemultianswer[question.listorder] = true;
        }

      }
    });
   
    if(AllValid)  
    {
      this.SelectedPackage.questionnaire.bookingid = this.NewBooking.bookingId;
      
      this.SelectedPackage.questionnaire.bookingquestions.forEach(question => {
        if(question.questiontype != "ALLERGY")
        {
          question.answers.allergypresent = false;
          question.answers.allergytext = "";
          question.answers.allergyanswer.allergypresent = false;
        }
        
      });

      this.http.post<booking_returndata>(bmxurl + "/questionanswers", this.SelectedPackage.questionnaire).subscribe(response => {
        this.httpResponse = response
        if (this.httpResponse.succeeded == true) {
          //this.setTab(Sections.Notes);

          if(this.packageExtras.length == 0)
            {
              this.setTab(Sections.Customer);
            }
            else
            {
              this.setTab(Sections.Extras);
            }
        }
        else
        {
          this.messageService.add({ severity: 'error', summary: 'Issue with birthday information:', detail:(this.httpResponse.messages[0])});
        }
      }, error => {
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.messages[0] });
      })
    }
  }

  isValidDate(dateString: string): boolean {
     //check if date is valid
      let date = new Date(dateString);
      return date instanceof Date && !isNaN(date.getTime());
  }

  IsToday()
  {
    var today = new Date();
    var selected = new Date(this.SelectedDate);
    return today.getDate() == selected.getDate() && today.getMonth() == selected.getMonth() && today.getFullYear() == selected.getFullYear();
  }

  IsDiscountValid(p)
  {
    if(p.earlybirddiscount)
    {
      if(p.discountrangetype == 0)
      {
        let dstartdate: Date = new Date(p.discountstart);
        let dstartend: Date = new Date(p.discountend);

        //if(dstartdate.getTime() <= this.CurrentDate.getTime() && dstartend.getTime() <= this.CurrentDate.getTime())
        if(this.CurrentDate.getTime() >= dstartdate.getTime() && this.CurrentDate.getTime() < dstartend.getTime())
        {
          return true;
        }
        else
        {
          return false;
        }
      }
      else
      {
        let today = new Date();
        today = new Date(today.toDateString());
        let bookingdate = new Date(this.SelectedDate);
        let diff = bookingdate.getTime() - today.getTime();
        let days = diff / (1000 * 3600 * 24);
        if(days >= p.discountdaysbefore)
        {
          return true;
        }
        else
        {
          return false;
        }
      }

    }
    else
    {
      return false;
    }

  }

  doReferralNote(){
    this.showDeferReason = false;

    this.NewBooking.inProgress = false;

    this.NewBooking.payments = null;
    this.NewBooking.deferredpayment = true;

    this.NewBooking.notes = (this.NewBooking.notes ?? "") + "DEFERRAL REASON: " + this.deferNotes;

    this.http.post<customer>(bmxurl + "/deferpayment", this.NewBooking).subscribe(response => {
      this.BookingResponse = response
      this.BookingDateAndTime = new Date(this.BookingResponse.data.startTime).getUTCDate().toString().padStart(2, '0') + "/" + new Date(this.BookingResponse.data.startTime).getUTCMonth().toString().padStart(2, '0') + "/" + new Date(this.BookingResponse.data.startTime).getUTCFullYear() + " " + new Date(this.BookingResponse.data.startTime).getUTCHours().toString().padStart(2, '0') + ":" + new Date(this.BookingResponse.data.startTime).getUTCMinutes().toString().padStart(2, '0');

      this.BookingPackage = this.BookingResponse.data.packageName;
    
      this.DoSummary(this.BookingResponse.data);

    }, error => {
    })

  }

  genRandomNum()
  {
    return Math.floor((Math.random()*10000)+1).toString();
  }

  changedPGSelection(selectedButton){
    this.packages = [];

    this.packageGroups.forEach(pg => {
      if(this.checked[pg.packagegroupid] != null)
      {
        if(this.checked[pg.packagegroupid] == true)
        {
          pg.packages.forEach(packagesInPG => {

            let found = false;  
            this.packages.forEach(pkg => {
              if(pkg.packageId == packagesInPG.packageId)
                found = true;
            });

            if(!found)
            {
              //if(new Date(packagesInPG.endDate).getTime() < new Date().getTime())
              //{
                this.packages.push(packagesInPG)
              //}
            }

            // if(!this.packages.includes(packagesInPG))
            //   this.packages.push(packagesInPG)
          });
        }
      }
    });
  }

  doneDiscount(){
    //send discount to server
    let dv: cDiscountvalidate = {
      booking: this.NewBooking,
      discountcode: this.discountCode.trim()
    }

    this.http.post<booking_returndata>(bmxurl + "/DiscountValidate", dv).subscribe(response => {
      this.httpResponse = response
      if (this.httpResponse.succeeded == true) {
        this.messageService.add({ severity: 'success', summary: 'Discount Added', detail: 'Your discount has been added' });

        this.showDiscount = false;
        this.discountCode = "";

        this.NewBooking = (response as booking_returndata).data;

        if(this.NewBooking.PublicBooking)
        {
          this.validPaymentAmount = this.NewBooking.totalpublicdeposit;

          if(this.NewBooking.totalpayments >= this.NewBooking.totalpublicdeposit)
            {
              this.completeWithoutPayment();
            }
            this.busyService.idle();
        }
        else{
          this.validPaymentAmount = this.NewBooking.totalvenuedeposit;

          if(this.NewBooking.totalpayments >= this.NewBooking.totalvenuedeposit)
            {
              this.completeWithoutPayment();
            }
            this.busyService.idle();
        }

      }
      else
      {
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail:(this.httpResponse.messages[0])});
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.messages[0] });
    })
  }

  doneOpenDiscount(){
        //send discount to server
        let dv: cOpenDiscountvalidate = {
          booking: this.NewBooking,
          value : this.chosenDiscountAmount
        }
    
        this.http.post<booking_returndata>(bmxurl + "/opendiscount", dv).subscribe(response => {
          this.httpResponse = response
          if (this.httpResponse.succeeded == true) {
            this.messageService.add({ severity: 'success', summary: 'Discount Added', detail: 'Your discount has been added' });
    
            this.showDiscount = false;
            this.discountCode = "";
    
            this.NewBooking = (response as booking_returndata).data;

            this.totalPayments = 0;
            this.BookingPayments.forEach(element => {
              this.totalPayments += element.amount;
            });
    
            if(this.NewBooking.PublicBooking)
            {
              this.validPaymentAmount = this.NewBooking.totalpublicdeposit;
            }
            else{
              this.validPaymentAmount = this.NewBooking.totalvenuedeposit;
            }

            if(this.NewBooking.totalvenuedeposit <= 0)
            {
              this.completeWithoutPayment();
            }
    
          }
          else
          {
            this.messageService.add({ severity: 'error', summary: 'Not Added', detail:(this.httpResponse.messages[0])});
          }
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.messages[0] });
        })
  }

  doneVoucher()
  {  
    this.busyService.busy();

    let newCustomer: any;

    newCustomer = this.NewBooking.customer;
    
    let dv: cVouchervalidate = {
      booking: this.NewBooking,
      vouchercode: this.voucherCode.trim(),
      voucherpin : this.voucherpin 
    }

    this.http.post<booking_returndata>(bmxurl + "/VoucherValidate", dv).subscribe(response => {
      this.httpResponse = response
      if (this.httpResponse.succeeded == true) {
        this.messageService.add({ severity: 'success', summary: 'Voucher Added', detail: 'Your voucher has been added' });

        this.showDiscount = false;
        this.discountCode = "";

        this.showVoucher = false;
        this.voucherCode = "";

        this.NewBooking = (response as booking_returndata).data;

        this.BookingPayments = this.NewBooking.payments;

        this.totalPayments = 0;
          this.BookingPayments.forEach(element => {
            this.totalPayments += element.amount;
          });

        this.NewBooking.customer = newCustomer;

        if(this.NewBooking.PublicBooking)
        {
          this.validPaymentAmount = this.NewBooking.totalpublicdeposit;
        }
        else{
          this.validPaymentAmount = this.NewBooking.totalvenuedeposit;
        }

        // if(this.NewBooking.totalpayments >= this.NewBooking.totalpublicdeposit)
        // {
        //   this.DoSummary(this.NewBooking);
        //   this.BookingComplete = true;
        // }
        // this.busyService.idle();

        if(this.NewBooking.totalvenuedeposit <= 0)
        {
          this.completeWithoutPayment();
        }

        this.busyService.idle();
      }
      else
      {
        this.busyService.idle();
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail:(this.httpResponse.messages[0])});
      }
    }, error => {
      this.busyService.idle();
      this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.error.messages[0] });
    })
  }

  displayDiscount(){
    this.showDiscount = !this.showDiscount;
  }

  displayVoucher(){
    this.showVoucher = !this.showVoucher;
  }
  
  donePartyRooms()
  {
    this.SelResourceHeader = "You selected: ";
    this.customerSelectedResources = [];
    
    let index = 0;
    this.SelectedResources.forEach(packResOriginal => {

      let packRes = JSON.parse(JSON.stringify(packResOriginal));

      if(packRes.optional == true)
      {
        if(this.SelectedSeletableResourceBool[index] == true)
        {
          packRes.ignore = false;
          if(packRes.resources.length > 0)
          {
              if(packRes.isconstructed && packRes.isresourcecontainer)
              {
                let resourceToSave: resource;
                packRes.resources.forEach(selectedRes => {
                  if(selectedRes != null)
                  {
                    if (selectedRes.id == this.SelectedSeletableResource[index])
                    {
                      resourceToSave = selectedRes;
                    }
                  }
                });
                
                packRes.resources = [];
                packRes.resources.push(resourceToSave);
              }
              this.customerSelectedResources.push(packRes);
              this.validselection[index] = true;
          }
          else
          {
            packRes.ignore = false;
            this.customerSelectedResources.push(packRes);
            this.SelResourceHeader += packRes.name + ", ";
          }
        }
        else
        {
          packRes.ignore = true;
          this.customerSelectedResources.push(packRes);
        }
      }
      else
      {
        if (this.SelectedSeletableResource[index] != null)
        {
          //if(packRes.selectionmode != "ANY" && packRes.selectionmode != "SYSTEMANY")
          //{
            let resourceToSave: resource;
            packRes.resources.forEach(selectedRes => {
              if (selectedRes.id == this.SelectedSeletableResource[index])
              {
                resourceToSave = selectedRes;
              }
            });
            
            packRes.resources = [];
            packRes.resources.push(resourceToSave);

            this.customerSelectedResources.push(packRes);
            this.validselection[index] = true;
        }
        else
        {
          this.customerSelectedResources.push(packRes);
          //A choice the customer makes has to be made, if there is anything to choose from.
          if(packRes.mode == "COMPLEX" && (packRes.selectionmode == "ANY" || packRes.selectionmode == "LIST") && packRes.resources.length > 0)
            this.validselection[index] = false;
          else if(packRes.mode != "SIMPLE")
            this.validselection[index] = true;
        }
      }
      index++;
    });

    let validationPassed = true;
    
    //Check validation:
    index = 0;
    this.customerSelectedResources.forEach(innerPackageRes => {
      if(innerPackageRes != null)
      {
        if(innerPackageRes.optional == true)
        {
          if (this.SelectedSeletableResourceBool[index] == true)
          {
            if(innerPackageRes.resources.length > 0)
            {
              if(innerPackageRes.resources[0] == null)
                this.validselection[index] = false;
              else
                this.validselection[index] = true;
            }
          }
          else
          {
            this.validselection[index] = true;
          }
        }
      }
      index++;
    });

    this.validselection.forEach(element => {
      if (element == false)
        validationPassed = false;
    });
    
    if (!validationPassed)
      return;


    this.SelectedPackage.resources = []

    this.customerSelectedResources.forEach(element => {
      if(!element.ignore)
      {
        this.SelectedPackage.resources.push(element);
        if(element.resources.length == 0)
        {
          if(element.mode != "SIMPLE")
            this.SelResourceHeader += element.name + ", ";
        }
        else
        {
          if(element.isresourcecontainer && !element.isconstructed)
          {
            if(element.mode != "SIMPLE")
              this.SelResourceHeader += element.name + ", ";
          }
          else
          {
            if(element.mode != "SIMPLE")
            {
              if(element.resources[0] != null)
                this.SelResourceHeader += element.resources[0].name + ", ";
            }
          }
        }
      }
    });
    

    if(this.SelResourceHeader.length > 2)
      this.SelResourceHeader = this.SelResourceHeader.substring(0, this.SelResourceHeader.length - 2)

      this.setTab(4);
      this.getAvailability();
  }

  addselectedCustomer(passCustomer){
    this.searchCriteria = "";

    this.CustomerHeader = "Customer: " +  passCustomer.firstName + "  " + passCustomer.lastName;

    let newCustomer: Customer = {
      id: passCustomer.id,
      customerid: passCustomer.customerid,
      firstName: passCustomer.firstName,
      lastName: passCustomer.lastName,
      fullName: passCustomer.firstName + " " + passCustomer.lastName,
      address1: passCustomer.address1,
      address2: passCustomer.address2,
      townCity: passCustomer.townCity,
      postCode: passCustomer.postCode,
      email: passCustomer.email,
      mobile: passCustomer.mobile,
      dob: this.dob,
      venueId: this.VenueID,
      disabled: false,
      bookingid: null
    }

    this.NewBooking.customer = newCustomer;


    this.busyService.idle();
    this.savebooking();

    this.setTab(Sections.Notes);
    
    this.customersResult = null;
    this.searchCriteria = "";
  }

  savebooking()
  {
    this.busyService.busy();
    this.http.post<booking_returndata>(bmxurl + "/savebooking", this.NewBooking).subscribe(response => {
      this.httpResponse = (response as booking_returndata);      

      if(this.httpResponse.succeeded)
      {
        this.busyService.idle();
        this.BookingResponse = this.httpResponse.data
        
        this.NewBooking = this.BookingResponse.bookingObj;

        let NumPeople: number = 0;
        this.NewBooking.resources[0].admissions.forEach(adm => {
          NumPeople += adm.noofpeople;
        });
  
        this.paymentAmount = this.BookingResponse.bookingObj.total;

        if(this.NewBooking.PublicBooking)
        {
          this.validPaymentAmount = this.NewBooking.totalpublicdeposit - this.NewBooking.totalpayments;
        }
        else{
          this.validPaymentAmount = this.NewBooking.totalvenuedeposit - this.NewBooking.totalpayments;
        }
  
        const formatter = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: this.CurrencySymbol});
  
        this.makeABookingHeader = "Make a Booking - Sales Value: " + formatter.format(this.paymentAmount);

        if (this.NewBooking.customer != null)
        {
          this.CustomerHeader = "Customer: " + this.NewBooking.customer.firstName + "  " + this.NewBooking.customer.lastName;
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: "No customer found"});
        }

        this.busyService.idle();
        this.setTab(Sections.Notes);

        if (this.SelectedPackage?.earlybirddiscount &&
            this.IsDiscountValid(this.SelectedPackage) &&
            this.SelectedPackage.discountcode &&
            this.NewBooking.totaldiscounts === 0) {
          this.applyEarlyBirdDiscount();
        }

      }
      else
      {
        //this.getAvailability();

        this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages});
        this.busyService.idle();

        this.returnHome();
      }
    }, error => {
      this.busyService.idle();
      this.messageService.add({severity:'error', summary:'Error', detail: error.message});

      this.returnHome();
    })
  }

  applyEarlyBirdDiscount(): void {
    const dv: cDiscountvalidate = {
      booking: this.NewBooking,
      discountcode: this.SelectedPackage.discountcode
    };

    this.http.post<booking_returndata>(bmxurl + "/DiscountValidate", dv).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded) {
        this.NewBooking = (this.httpResponse as booking_returndata).data;

        if (this.NewBooking.PublicBooking) {
          this.validPaymentAmount = this.NewBooking.totalpublicdeposit - this.NewBooking.totalpayments;
        } else {
          this.validPaymentAmount = this.NewBooking.totalvenuedeposit - this.NewBooking.totalpayments;
        }

        const formatter = new Intl.NumberFormat('en-GB', { style: 'currency', currency: this.CurrencySymbol });
        this.makeABookingHeader = "Make a Booking - Sales Value: " + formatter.format(this.NewBooking.total);
      }
    });
  }

  showMemberships(data)
  {
    let mshipd = document.getElementById("div-" + data.id);
    mshipd.style.display = mshipd.style.display === "none" ? "" : "none";
  }

  addselectedMember(passMember)
  {
    this.http.get(bmxurl + "/validatemembership/" + this.NewBooking.bookingId + "/" + passMember.salesid + "/" + passMember.membershippin).subscribe(response => {
    this.httpResponse =  (response as any);

    if(this.httpResponse.succeeded)
      {
        this.NewBooking = this.httpResponse.data;

        this.CustomerHeader = "Customer: " +  this.firstName + "  " + this.lastName;

        this.messageService.add({severity:'success', summary:'Success', detail: this.httpResponse.messages});

        if(this.NewBooking.PublicBooking)
        {
          this.paymentAmount = this.NewBooking.totalpublicdeposit;
        }
        else
        {
          this.paymentAmount = this.NewBooking.totalvenuedeposit;
        }

        if (this.NewBooking.customer != null)
        {
          this.CustomerHeader = "Customer: " + this.NewBooking.customer.firstName + "  " + this.NewBooking.customer.lastName;
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: "No customer found"});
        }

        this.setTab(Sections.Notes);
        this.busyService.idle();

      }
      else
      {
        this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages[0]});
        this.busyService.idle();
      }
    });
  }

  addCustomer(){
    //Check Search field for postcode

    if(this.valid_postcode(this.searchCriteria))
    {
      this.postCode = this.searchCriteria
    }
    else if(this.valid_mobile(this.searchCriteria))
    {
      //Check Telephone number
      this.mobile = this.searchCriteria
    }
    else if(this.searchCriteria.includes("@"))
    {
      this.email = this.searchCriteria
    }
    else
    {
      this.lastName = this.searchCriteria
    }


    this.ShowCustomerDetails = true;
    //this.ProvideMinimalPersonalData = "FULL";
  }

  doWalkin(){
    this.customersResult = null;
    this.ProvideMinimalPersonalData = "WALKIN";
    this.lastName = this.searchCriteria;
    this.ShowCustomerDetails = true;
  }

  valid_postcode(postcode) {
    postcode = postcode.replace(/\s/g, "");
    var regex = /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i;
    return regex.test(postcode);
  }

  valid_mobile(postcode) {
    postcode = postcode.replace(/\s/g, "");
    var regex = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
    return regex.test(postcode);
  }

  ngAfterViewChecked(): void {
    if (this.pendingScrollToFirstTime) {
      const firstTime = document.querySelector('.times');
      if (firstTime) {
        this.pendingScrollToFirstTime = false;
        firstTime.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  //The single date of every extra, by extraId, read from the extras themselves. The copies held on
  //a package are taken when the extra is added to it, so ones added before singledate existed - or
  //an extra whose date changed since - carry no date or the wrong one.
  private loadExtraSingleDates() {
    this.http.get<any>(bmxurl + "ExtraList/" + this.VenueID + "/false").subscribe(response => {
      let dates: { [extraId: string]: string } = {};
      let variable: { [extraId: string]: boolean } = {};

      (response?.data ?? []).forEach(ext => {
        if (ext.extraId != null)
        {
          dates[ext.extraId] = ext.singledate;
          variable[ext.extraId] = ext.variablevalue == true;
        }
      });

      this.extraSingleDates = dates;
      this.extraVariableValues = variable;
    }, error => {
      //Left empty: the package's own copy of the date is used instead.
    });
  }

  //The extra's own date wins; the package copy is only used when the extras list has not loaded.
  private extraSingleDate(ext: any): string {
    return this.extraSingleDates[ext.extraId] ?? ext.singledate;
  }

  //Whether an extra is variable value: no set price, staff type the value in on the booking and
  //it is saved as that extra's price. Read from the extra itself first, for the same reason as
  //the single date - a copy on a package or a booking may predate the setting.
  isVariableValueExtra(ext: any): boolean {
    if (ext == null)
      return false;

    return (this.extraVariableValues[ext.extraId] ?? ext.variablevalue) == true;
  }

  //A variable value extra that has been added needs a value typed in before it can be saved.
  variableValueMissing(ext: any): boolean {
    return this.isVariableValueExtra(ext) && Number(ext.qty) > 0 && !(Number(ext.price) > 0);
  }

  ngOnInit(): void {

    //A booking the AI-Assistant prepared, if staff confirmed one to get here - see applyPrefill.
    this.prefill = this.bookingPrefillService.take();

    //get payment types
    this.PaymentTypes = JSON.parse(localStorage.getItem("PaymentTypes"));

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");

    let userid = localStorage.getItem("SmartUserID");
    
    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("MAKEABOOKING", user)){
          this.AccessAllowed = true;
          this.loadExtraSingleDates();

          let inputtedDate = "";
          this.route.queryParams
            .subscribe(params => {
              inputtedDate = params.bookingDate + "UTC";
            }
          );
      
          this.BookingPayments = [];
          this.totalPayments = 0;
      
          this.partyroomsVisible = true;
          this.id = this.route.snapshot.paramMap.get('id');

          this.qbook = this.route.snapshot.paramMap.get('qbook');

          this.packages = [];
          this.customerSelectedResources = [];
          this.SelectedResources = [];
      
          this.checked = [];

          this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
            this.httpResponse = (response as venuesettings_returndata)
            if(this.httpResponse.succeeded)
            {
              this.httpResponse.data.venueSettings.forEach(element => {
                if (element.name == "UseIntervalAvailability") {
                  this.UseIntervalAvailability = element.value;
                }
                if (element.name == "NoAvailabilityMessage") {
                  this.NoAvailabilityMessage = element.value;
                }
              });
            }
            else
            {
              this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Venue Settings.'});
            }
          }, error => {
            this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Venue Settings.'});
          })
      
          if(this.id == "0")
          {
            if(inputtedDate != undefined && inputtedDate != "" && inputtedDate != "undefined" && inputtedDate != "undefinedUTC")
            {
              this.SelectedDate = this.DatifyString(inputtedDate);
              this.timetobetried = inputtedDate.substring(11, 16);

              inputtedDate = "";
              this.dateSelected = true;
              this.packageSelected = false;
              this.admissionsSelected = false;
              this.doneDate();
            }
            else
            {
              if (this.qbook != "true")
              {
                this.dateSelected = true;
                this.packageSelected = false;
                this.admissionsSelected = false;
                this.setTab(Sections.Date);
              }
              else
              {
                this.SelectedDate = new Date();
                this.doneDate();
                this.setTab(Sections.Package);
              }
            }
          }
          else
          {
            this.http.get(bmxurl + "booking/" + this.VenueID + "/" + this.id).subscribe(response => {
              this.NewBooking = (response as booking_returndata).data;
              if((response as booking_returndata).succeeded)
              {
                this.SelectedDate  = new Date(this.NewBooking.startTime);
              }
              else{
                this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Booking.'});
              }
            }, error => {
              this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Booking.'});
            })
      
            this.dateSelected = true;
            this.setTab(Sections.Date);
      
            this.dateActive = false;
            this.packageActive = false;
            this.admissionsActive = false;
            this.timeActive = false;
            this.customerActive = false;
            this.paymentActive = false;
            this.extraActive = false;
            this.notesActive = false;
          }
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

  }

  DatifyString(date: string): Date
  {
    let returnDate = new Date();

    returnDate.setUTCFullYear(Number(date.substring(0, 4)));
    returnDate.setUTCMonth(Number(date.substring(5, 7)) - 1);
    returnDate.setUTCDate(Number(date.substring(8, 10)));
    returnDate.setUTCHours(0);
    returnDate.setUTCMinutes(0);
    returnDate.setUTCSeconds(0);

    return returnDate;
  }

  Selectpopular(){
    //Get Popular Group
    let PopularGroup: cPackagegroups;
    this.packageGroups.forEach(pkgrp => {
      if(pkgrp.packagegroupname == 'Popular')
        PopularGroup = pkgrp;
    });

    this.packages1.forEach(pkg => {
      PopularGroup.packages.forEach(PGPgs => {
        if(PGPgs.packageId == pkg.packageId)
          this.packages.push(pkg)
      });
    });
    
    this.checked[PopularGroup.packagegroupid] = true;
  }

  sumAdmissions(){

    this.doLinkedDiscounts();

    this.doLinkedAdmissions();

    this.maxadmissions = 0;
    this.minadmissions = 0;
    this.totalAdmissions = 0;

    this.SelectedAdmissions.forEach(adm => {
      if(adm.countstowardsmin || adm.countstowardsmin == null)
      {
        this.minadmissions += Number(adm.noofpeople);
        this.totalAdmissions += Number(adm.noofpeople);
      }

    });

    if((this.totalAdmissions > this.SelectedPackage.max && this.SelectedPackage.max > 0) || (this.minadmissions < this.SelectedPackage.min && this.SelectedPackage.min > 0))
    {
      this.totalAdmissionInRange = false;
    }
    else
    {
      this.totalAdmissionInRange = true;
    }
  }

  doLinkedDiscounts()
  {
    this.totalDiscount = 0;

    let totalNumberOfLinkedDiscounts = 0;

    this.SelectedAdmissions.forEach(adm => {

      if(adm.linkeddiscounts != null)
      {
        adm.linkeddiscounts.forEach(ladm => {
          let linkedDis = this.SelectedAdmissions.find(a => a.admissionid == ladm.admissionid);

          if(linkedDis != null)
          {
            if(linkedDis.noofpeople >= ladm.threshold)
            {
              let numberOfPeopleForDiscount = Math.floor(linkedDis.noofpeople / ladm.threshold);

              if(adm.noofpeople < numberOfPeopleForDiscount)
              {
                numberOfPeopleForDiscount = adm.noofpeople;
              }

              this.totalDiscount += Number(adm.price * numberOfPeopleForDiscount) * Number(ladm.percentagediscount / 100);
            }
          }
        });
      }
    });
  }

  doLinkedAdmissions() {
  this.SelectedAdmissions.forEach(adm => {
    if (adm.linkedadmissions && adm.linkedadmissions.length > 0) {
      let totalNumberOfLinked = 0;

      adm.linkedadmissions.forEach(ladm => {
        const matching = this.SelectedAdmissions.find(innerAdm => innerAdm.admissionid === ladm.admissionid);
        if (matching) {
          totalNumberOfLinked += Number(matching.noofpeople);
        }
      });

      if (adm.onlysetmax) {
        adm.max = Number(totalNumberOfLinked);

        if (adm.max < adm.min) {
          adm.max = adm.min;
        }

        if (Number(adm.noofpeople) > adm.max) {
          adm.noofpeople = adm.max;
        }

        adm.fixed = false;
      } else {
        adm.noofpeople = Number(totalNumberOfLinked);
        adm.fixed = true;
      }
    }
  });
}

  // doLinkedAdmissions2()
  // {
  //   let totalNumberOfLinked = 0;

  //   this.SelectedAdmissions.forEach(adm => {

  //     if(adm.linkedadmissions != null && adm.linkedadmissions.length > 0)
  //     {
  //       adm.linkedadmissions.forEach(ladm => {
  //         totalNumberOfLinked = 0;
  //         this.SelectedAdmissions.forEach(innerAdm => {
  //           if(ladm.admissionid == innerAdm.admissionid)
  //           {
  //             totalNumberOfLinked += Number(innerAdm.noofpeople);
  //           }
  //         });
  //       });

  //       if(adm.onlysetmax)
  //       {
  //         adm.max = Number(totalNumberOfLinked);
  //         if (adm.max < adm.min)
  //         {
  //           adm.max = adm.min;
  //         }
  //         if(Number(adm.noofpeople) > Number(totalNumberOfLinked))
  //         {
  //           adm.noofpeople = Number(totalNumberOfLinked);
  //         }
  //         adm.fixed = false;
  //       }
  //       else
  //       {
  //         adm.noofpeople = Number(totalNumberOfLinked);
  //         adm.fixed = true;
  //       }
  //     }
  //   });

  // }

  // doLinkedAdmissions()
  // {
  //   if(this.VenueID == 'ebfc03ad-d3f8-4289-8d65-055c93a7f56d')
  //   {
  //     this.doLinkedAdmissions2();
  //   }
  //   else
  //   {
  //     let totalNumberOfLinked = 0;

  //     this.SelectedAdmissions.forEach(adm => {

  //       let OldNoOfPeople = adm.min;

  //       if(adm.linkedadmissions != null)
  //       {
  //         adm.linkedadmissions.forEach(ladm => {
  //           let linkedAdm = this.SelectedAdmissions.find(a => a.admissionid == ladm.admissionid);

  //           if(linkedAdm != null)
  //           {
  //             totalNumberOfLinked += Number(linkedAdm.noofpeople);
  //           }
  //         });

  //         if(adm.onlysetmax)
  //         {
  //           adm.max = Number(totalNumberOfLinked);
  //           if (adm.max < adm.min)
  //           {
  //             adm.max = adm.min;
  //           }
  //           if(Number(adm.noofpeople) > Number(totalNumberOfLinked))
  //           {
  //             if(Number(OldNoOfPeople) > Number(totalNumberOfLinked))
  //             {
  //               adm.noofpeople = Number(OldNoOfPeople);
  //             }
  //             else
  //             {
  //               adm.noofpeople = Number(totalNumberOfLinked);
  //             }
  //           }
  //           adm.fixed = false;
  //         }
  //         else
  //         {
  //           adm.noofpeople = Number(totalNumberOfLinked);
  //           adm.fixed = true;
  //         }
  //       }
  //     });
  //   }
  // }

  applyCustomer(passCustomer)
  {
    this.ShowCustomerDetails = true;
    this.firstName = passCustomer.firstName;
    this.lastName = passCustomer.lastName;
    this.address1 = passCustomer.address1;
    this.address2 = passCustomer.address2;
    this.town = passCustomer.townCity;
    this.postCode = passCustomer.postCode;
    this.email = passCustomer.email;
    this. mobile = passCustomer.mobile;

    this.customersResult = null;
    this.searchCriteria = "";

  }

  // GetCustomerMemberships(data){
  //   this.http.get(bmxurl + "Customer/Memberships/" + this.VenueID + "/" + data.customerid).subscribe(response => {
  //     this.customerMemberships = ((response as any).data) as membership[];
  //   }, error => {
  //   });
  // }

  searchCustomer(){
    this.http.get(bmxurl + "customer/search/" + this.VenueID + "/" + this.searchCriteria).subscribe(response => {
      this.customersResult = (response as customer[])
      }, error => {
        })

  }

  VCContinue()
  {
    this.showVCWarning = false;
  }

  doneDate()
  {
    this.busyService.busy();
    this.CalendarHeader = "You selected: " + this.SelectedDate.toDateString();
    this.packages = [];

    this.http.get(bmxurl + "PackageGroupList/" + this.VenueID + "/false/" + 
    ('00' + this.SelectedDate.getDate()).slice(-2)+
    ('00' + (Number(this.SelectedDate.getMonth() + 1).toString())).slice(-2)
    +this.SelectedDate.getFullYear().toString().substr(-2)
    ).subscribe(response => {
      this.packageGroups = (response as packagegroups_returndata).data;
      this.prefillPackage();
      this.busyService.idle();
      
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Package Groups.'});
    })

    //Does a current booking exist for this date?
    if(this.NewBooking.bookingId != null)
    {
      // let abandonBooking: any = {
      //   bookingid: this.NewBooking.bookingId,
      //   jwt: null
      // }
      // //Booking Exists, abandon it
      // this.http.post(bmxurl + "abandonbooking/", abandonBooking).subscribe(response => {
      //   this.NewBooking = (response as booking_returndata).data;

      // }, error => {
      //   this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to abandon booking.'});
      // });

      this.SelectedPackage = null;
      this.SelectedAdmissions = [];
      this.SelectedResources = [];
      this.customerSelectedResources = [];
      
      this.PackageHeader = "Select a Package";
      this.CalendarHeader = "Select a Date";
      this.AdmissionHeader = "Select your Admissions";
      this.TimeHeader = "Select a Time";
      this.CustomerHeader = "Create a Customer";
      this.PaymentHeader = "Add a Payment";
      this.ExtrasHeader = "Select Extras";

      this.NewBooking.id = null;
      this.NewBooking.bookingId = null;
      this.AvailabilityReq = {} as AvailabilityReq;

    }

    let BookingDateYear = this.SelectedDate.getFullYear().toString().substr(-2);
    let BookingDateMonth = ('00' + (this.SelectedDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.SelectedDate.getDate()).slice(-2);

    let dateChosen = BookingDateDay + BookingDateMonth + BookingDateYear;

    this.http.get<venueclosings_returndata>(bmxurl + "/VenueClosingList/" + this.VenueID + "/false/" + dateChosen).subscribe(response => {
      this.venueClosings = (response as venueclosings_returndata).data;

      if(this.venueClosings != null)
      {
        this.venueClosings.forEach(element => {
            if(element.venueMessage != null && element.venueMessage != "")
            {
              this.VCWarningMessage += element.venueMessage + "<BR>";
              this.showVCWarning = true;
            }
        });
      }
      else
      {
        this.showVCWarning = false;
      }
    });

    this.AbandonBooking();
    this.checked = [];
    
    this.setTab(Sections.Package);
  }

  toggleMore(inDiv)
  {
    let collapsedDiv = document.getElementById(inDiv + "collapse") as HTMLElement;
    let expandeddDiv = document.getElementById(inDiv + "expanded") as HTMLElement;
    let toggleButton = document.getElementById(inDiv + "toggleButton") as HTMLButtonElement;

    if(collapsedDiv.hidden == true)
    {
      collapsedDiv.hidden = false
      collapsedDiv.style.display = "false";
    }
    else
    {
      collapsedDiv.hidden = true
      collapsedDiv.style.display = "true";
    }

    if(expandeddDiv.hidden == true)
    {
      expandeddDiv.hidden = false
      expandeddDiv.style.display = "false";
    }
    else
    {
      expandeddDiv.hidden = true
      expandeddDiv.style.display = "true";
    }

    if(toggleButton.value == "Show More...")
    {
      toggleButton.value = "Show Less..."
      toggleButton.textContent = "Show Less..."
    }
    else
    {
      toggleButton.value = "Show More..."
      toggleButton.textContent = "Show More..."
    }
  }

  //A row in PackageGroupList may not carry a LIST's ticks. If it does not, they come from the package
  //read in full, and the options on the room step are worked out again.
  private loadMissingTicks() {
    const missing = this.SelectedResources.filter(entry => entry.mode == "COMPLEX" && entry.selectionmode == "LIST" && selectableResourceIds(entry).length == 0);

    if (missing.length == 0) {
      return;
    }

    const packageId = this.SelectedPackage.packageId;
    this.busyService.busy();

    this.http.get(bmxurl + "package/" + this.VenueID + "/" + packageId).subscribe(response => {
      //Another package may have been picked while this was on its way.
      if (this.SelectedPackage?.packageId == packageId) {
        const fullGroups: any[] = (response as any)?.data?.resources ?? [];

        missing.forEach(entry => {
          const full = fullGroups.find(item => item.id == entry.id) ?? fullGroups.find(item => item.resourceId == entry.resourceId);
          const group = this.SelectedPackage.resources.find(item => item.id == entry.id);

          if (full != null) {
            entry.selectableresourcestrings = full.selectableresourcestrings;
            entry.resources = selectedResources(full).filter(res => res.disabled != true);
            if (group != null) {
              group.selectableresourcestrings = full.selectableresourcestrings;
            }
          }
        });
      }
      this.busyService.idle();
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'Could not read which resources this package offers.'});
      this.busyService.idle();
    });
  }

  donePackage(inPackage)
  {
    //A copy, as donePartyRooms cuts the package down to what was chosen and the list keeps the original.
    this.SelectedPackage = JSON.parse(JSON.stringify(inPackage));

    this.includesComplexResources = false;
    this.includesOptionalResources = false;
    this.systemChoosesAllResources = true;
    this.SelectedSeletableResource = [];
    this.SelectedSeletableResourceBool = [];
    this.validselection = [];

    if(this.SelectedPackage.questionnaire != null)
    {
      for(var i = 0; i < this.SelectedPackage.questionnaire.bookingquestions.length; i++)
      {
        this.mustanswerallergies[i] = true;
        this.mustanswerbirthdays[i] = true;
        this.mustanswernumber[i] = true;  
        this.mustanswerfreetext[i] = true;
        this.mustanswermultichoicesingleanswer[i] = true;
        this.mustanswermultichoicemultianswer[i] = true;
        this.mustanswerdate[i] = true;
        this.allergyAnswer[i] = true;  
        this.mustanswerage[i] = true;
      }
    }

    this.timeoutTime = this.SelectedPackage.bookingtimeout;

    this.customerSelectedResources = [];
    this.SelectedResources = [];
    
    this.PackageHeader = "You selected: " + this.SelectedPackage.name;

    this.SelectedAdmissions = [];

    this.SelectedPackage.admissions.forEach(adm => {
      var newAdm: admission = {
        id: adm.id,
        admissionid: adm.admissionid,
        classid: adm.classid,
        noofpeople: adm.min,
        price: adm.price,
        name: adm.name,
        index: adm.index,
        max: adm.max,
        min: adm.min,
        venueid: adm.venueid,
        disabled: adm.disabled,
        admissionClass: adm.admissionClass,
        bookingwizardtext: adm.bookingwizardtext,
        fixedPrice: adm.fixedPrice,
        participant: adm.participant,
        mustinclude: adm.mustinclude,
        eventtickettype: adm.eventtickettype,
        counter: [],
        uselinkeddiscounts: adm.uselinkeddiscounts,
        linkedadmissions: adm.linkedadmissions,
        linkeddiscounts: adm.linkeddiscounts,
        uselinkedadmissions: adm.uselinkedadmissions,
        maxlinkeddiscounts: adm.maxlinkeddiscounts,
        maxlinkedadmissions:adm.maxlinkedadmissions,
        countstowardsmax: adm.countstowardsmax,
        countstowardsmin: adm.countstowardsmin,
        message: adm.message,
        fixed: adm.fixed,
        onlysetmax: adm.onlysetmax
    }

    this.doLinkedAdmissions();


    this.SelectedAdmissions.push(newAdm);
    });

    this.SelectedPackage.resources.forEach(res => {

      const selectableinnerresources: any[] = selectedResources(res).filter(innerRes => innerRes.disabled != true);

      var newRes: cResource = {
        groupname: uuidv4(),
        id: res.id,
        resourceId: res.resourceId,   
        name: res.name,
        useClasses: res.useClasses,
        exclusive: res.exclusive,
        eventid: res.eventid,
        concurrentUses: res.concurrentUses,
        maxConcurrent: res.maxConcurrent,
        disabled: res.disabled,
        venueId: res.venueId,
        colour: res.colour,
        orderindex: res.orderindex,
        length: res.length,
        classes:  res.classes,
        showonbooking:res.showonbooking,
        resources: selectableinnerresources,
        isresourcecontainer: res.isresourcecontainer,
        isconstructed: res.isconstructed,
        resourcegroupname: res.resourcegroupname,
        price: res.price,
        fixedprice: res.fixedprice,
        tags: res.tags,
        resourcegroup: res.resourcegroup,
        selectionmode: res.selectionmode,
        selectableresourcestrings: res.selectableresourcestrings,
        startwhen: res.startwhen,
        startTimeOffset: res.startTimeOffset,
        optional: res.optional,
        quantityselector: res.quantityselector,
        quantity: res.quantity,
        mode: res.mode,
        inline: res.inline,
        ignore: res.ignore,
        admissions: res.admissions,
        inProgress: res.inProgress,
        originatingid: res.originatingid,
        wasoptional: res.wasoptional,
        wasselected: res.wasselected,
        isupgrade: res.isupgrade,
        packageupgradeid: res.packageupgradeid,
        showinitinerary: res.showinitinerary,
        showondaysheet: res.showondaysheet,
        cansplit: res.cansplit
    }

    this.SelectedResources.push(newRes);
    });

    this.loadMissingTicks();

    //Get day for selected date.
    let day = this.SelectedDate.getDay();

    this.packageExtras = [];

    if(this.SelectedPackage.extras != null)
    {
      switch (day)
      {
        case 0:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.sunday == true);
          break;
        case 1:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.monday == true);
          break;
        case 2:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.tuesday == true);
          break;
        case 3:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.wednesday == true);
          break;
        case 4:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.thursday == true);
          break;
        case 5:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.friday == true);
          break;
        case 6:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.saturday == true);
          break;
        default:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.sunday == true);
          break;
      }
    }

    this.packageExtras = this.packageExtras.filter(ext => ext.disabled == false)

    //An extra limited to a single date only shows when the booking is on that date.
    this.packageExtras = this.packageExtras.filter(ext => extraAvailableOnDate({ singledate: this.extraSingleDate(ext) }, this.SelectedDate));

    this.packageExtras.forEach(ext => {
      ext.qty = 0;

      //A variable value extra starts with no value, so staff have to type one in. It is added
      //once or not at all, so its quantity is pinned here as well as on the package - a package
      //saved before that rule existed still carries whatever min and max it was given.
      if (this.isVariableValueExtra(ext)) {
        ext.price = null;
        ext.min = 0;
        ext.max = 1;
      }
     });

     if(this.packageExtras.length > 0)
        this.PackageHasExtras = true;

    //Across all of them - any one can need the room step, not just the last.
    this.SelectedResources.forEach(element => {
      if(element.mode == "COMPLEX" && element.selectionmode != "SYSTEMANY" && element.selectionmode != "SYSTEMLIST" && element.selectionmode != "")
      {
        this.includesComplexResources = true;
      }

      if(element.selectionmode != "SYSTEMANY" && element.selectionmode != "SYSTEMLIST")
      {
        this.systemChoosesAllResources = false;
      }

      if(element.optional)
      {
        this.includesOptionalResources = true;
      }
    });

    if(!this.includesComplexResources || this.systemChoosesAllResources)
    {
      this.customerSelectedResources = this.SelectedPackage.resources;
    }

    if(this.includesComplexResources)
    {
      this.partyroomsVisible = true;
    }
    else
    {
      this.partyroomsVisible = false;
    }

    this.sumAdmissions();
    this.AbandonBooking();
    this.setTab(Sections.Admissions);

    if(this.SelectedPackage.warning != null)
      {
        if(this.SelectedPackage.warning.venuemessage != null && this.SelectedPackage.warning.venuemessage != "")
        {
          this.showWarning = true;
          this.WarningMessage = this.SelectedPackage.warning.venuemessage;
        }
      }
  }

  doneAdmissions()
  {

   this.busyService.busy();

   let dropOut = false;
   let HasMustIncludes = false;
   let HasSelectedMustIncludes = false;

   this.SelectedAdmissions.forEach(element => {
       if(element.mustinclude)
       {
        HasMustIncludes = true;
       }
       if(element.mustinclude && element.noofpeople > 0)
       {
        HasSelectedMustIncludes = true;
       }
   });

   if(HasMustIncludes && !HasSelectedMustIncludes)
    {
      this.MustIncludePass = false;
      this.messageService.add({severity:'warn', summary:'Must include', detail:'You must include at least 1 of the admissions with an asterix'});
      this.busyService.idle(); 
    }
    else
    {
      this.MustIncludePass = true;
    }

    if(this.totalAdmissionInRange)
    {
      if(this.MustIncludePass)
      {
        let AdmissionsList: string = "";

        this.SelectedAdmissions.forEach(adm => {
          if(adm.noofpeople > 0)
            AdmissionsList += adm.noofpeople + " x " +  adm.name + ", ";
        });

        if(AdmissionsList.length > 2)
        AdmissionsList = AdmissionsList.substring(0, AdmissionsList.length - 2);

        this.AdmissionHeader = "You selected: " + AdmissionsList;

        this.AbandonBooking();

        
        if(this.SelectedPackage.questionnaire != null)
          {
            this.SelectedPackage.questionnaire.bookingquestions.forEach(question => {
      
              let bQuestions = [];
              if(this.isPersonListQuestion(question.questiontype) && !question.linkedtoparticipants)
              {
                //The rows belong to this question alone. They used to be poured into one
                //array shared by every birthday question, so a second question overwrote the
                //first and both then showed the same people.
                bQuestions.push({
                  index: 0, 
                  id: uuidv4(), 
                  name: "", 
                  age: 0, 
                  birthdate: "",
                  gender: "NOT STATED",
                  interests: "",
                  showage: question.showage,
                  showdob: question.showdob,
                  showgender: question.showgender,
                  showinterests: question.showinterests,
                  dobday: question.dobday,
                  dobmonth: question.dobmonth,
                  dobyear: question.dobyear
                });
              }
              else if(this.isPersonListQuestion(question.questiontype) && question.linkedtoparticipants)
              {
                let totalAllowed = 0;
  
                this.SelectedAdmissions.forEach(admission => {
                  if (admission.participant)
                  {
                    totalAllowed += admission.noofpeople;
                  }
                });
  
                let index = 0;
  
                for(var i = 0; i < totalAllowed; i++){
                  bQuestions.push({
                    index: index, 
                    id: uuidv4(), 
                    name: "", 
                    age: 0, 
                    birthdate: new Date(),
                    gender: "NOT STATED",
                    interests: "",
                    showage: question.showage,
                    showdob: question.showdob,
                    showgender: question.showgender,
                    showinterests: question.showinterests,
                    dobday: question.dobday,
                    dobmonth: question.dobmonth,
                    dobyear: question.dobyear
                  });
  
                  index++;
                }
              }


              question.answers = {
                bookingid: "",
                bookingquestionnaireid:  null,
                bookingquestionid: question.bookingquestionid,
                birthdayanswers: bQuestions,
                allergyanswer: {
                  id: null,
                  allergypresent: null,
                  allergytext: ""
                },
                freetextanswer: "",
                numberanswer: null,
                dateanswer:  null,
                multichoicesingleanswer: {
                  id: null,
                  listitemtext: ""
                },
                multichoicemultianswer: []
              }
            });
        }
  

        if((this.includesComplexResources && !this.systemChoosesAllResources) || this.includesOptionalResources)
        {
          this.busyService.idle();  
          this.setTab(Sections.Partyroom);
        }
        else{
          this.setTab(Sections.Time);
          this.getAvailability();
        }
      }
    }
    else
    {
      this.busyService.idle();  

      if (this.totalAdmissions > this.SelectedPackage.max)
      {
        this.messageService.add({severity:'warn', summary:'Admissions', detail:'There are too many admissions, please reduce the admissions to ' + this.SelectedPackage.max + ' or less.'});
      }
      if (this.totalAdmissions < this.SelectedPackage.min)
      {
        this.messageService.add({severity:'warn', summary:'Admissions', detail:'There are too few admissions, please increase the admissions to ' + this.SelectedPackage.min + ' or more not including any excluded admissions'});
      }
    }

    this.linkedAdmissionMessageShown = false;
  }

  Checkfortoday()
  {
    var today = new Date();
    var selected = new Date(this.SelectedDate);
    return today.getDate() == selected.getDate() && today.getMonth() == selected.getMonth() && today.getFullYear() == selected.getFullYear();
  }

  bookSlot(timeslot: AvailableTimes)
  {
    this.globalTimeSlot = timeslot;

    this.restartTimer(this.SelectedPackage.bookingtimeout);
    this.showTimer = true;

    this.PBWStartTime = new Date();

    if(timeslot != null)
    {
      this.busyService.busy();
      this.TimeHeader = "You selected: " + new Date(timeslot.time).getUTCHours().toString().padStart(2, '0') + ":" + new Date(timeslot.time).getUTCMinutes().toString().padStart(2, '0');

      var instanceID: any = "BMP1"
      var id:any = this.VenueID;
      var todaysDate: Date = new Date(timeslot.time);
      var venueDate: any =  id + "_" + timeslot.time.toString().substring(0, 10).replace(/-/g, "");

      this.SelectedPackage.resources.forEach(adm => {
        adm.admissions = this.SelectedAdmissions;
      });

      let totalNoOfPeople: number = 0;
      this.NewBooking.bookingIdHR = null;
      this.NewBooking.venuedate = venueDate;
      this.NewBooking.packageId = this.SelectedPackage.packageId;
      this.NewBooking.guests =  totalNoOfPeople;
      this.NewBooking.startTime = timeslot.time;
      this.NewBooking.PackageName = this.SelectedPackage.name;
      this.NewBooking.venueId = this.VenueID;
      this.NewBooking.payments = null;
      this.NewBooking.customer = null;
      this.NewBooking.resources = timeslot.resources; //this.SelectedPackage.resources;
      this.NewBooking.Disabled = false;
      this.NewBooking.outstanding = 0;
      this.NewBooking.name = "";
      this.NewBooking.inProgress = true;
      this.NewBooking.availabilityreq = this.AvailabilityReq;
      this.NewBooking.initialbooking = true;
      this.NewBooking.salestype = 0;
      this.NewBooking.currency = this.CurrencySymbol;

      if(this.SelectedPackage.bookingtimeout == 0)
      {
        this.NewBooking.bookingtimeout = 300;
      }
      else
      {
        this.NewBooking.bookingtimeout = this.SelectedPackage.bookingtimeout;
      }

      this.NewBooking.resources.forEach(element => {
        element.inProgress = true;
      });

      this.http.post<booking_returndata>(bmxurl + "/savebooking", this.NewBooking).subscribe(response => {
        this.httpResponse = (response as booking_returndata);      

        if(this.httpResponse.succeeded)
        {
          this.BookingResponse = this.httpResponse.data
          
          this.NewBooking = this.BookingResponse.bookingObj;

          let NumPeople: number = 0;
          this.NewBooking.resources[0].admissions.forEach(adm => {
            NumPeople += adm.noofpeople;
          });
    
          this.paymentAmount = this.BookingResponse.bookingObj.total;

          if(this.NewBooking.PublicBooking)
          {
            this.validPaymentAmount = this.NewBooking.totalpublicdeposit - this.NewBooking.totalpayments;
          }
          else{
            this.validPaymentAmount = this.NewBooking.totalvenuedeposit - this.NewBooking.totalpayments;
          }
    
          const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: this.CurrencySymbol});
    
          this.makeABookingHeader = "Make a Booking - Sales Value: " + formatter.format(this.paymentAmount);
          
          if(this.SelectedPackage.packageupgrades != null && this.SelectedPackage.packageupgrades.length > 0)
          {
            let timedate = this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ timeslot.timeString + ":00.000Z"

            this.getUpgradeAvailability(this.SelectedPackage.packageupgrades, timedate);
          }
          else
          {
            if(this.SelectedPackage.packageabupgrades != null && this.SelectedPackage.packageabupgrades.length > 0)
            {
              let timedate = this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ timeslot.timeString + ":00.000Z"

              this.getOptionalUpgradeAvailability(this.SelectedPackage.packageabupgrades, timedate);
            }
            else
            {
              if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
              {
                this.setTab(Sections.Customer);
              }
              else if(this.SelectedPackage.questionnaire != null)
              {
                this.setTab(Sections.BookingQuestions);
              }
              else
              {
                this.setTab(Sections.Extras);
              }
            }

            this.busyService.idle();
            this.upgradesComplete = true;
          }
        }
        else
        {
          this.getAvailability();
          
          this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages});
          this.busyService.idle();
        }
      }, error => {
          this.busyService.idle();
        this.messageService.add({severity:'error', summary:'Error', detail: error.message});
      })
    }
    else
    {
      this.showTimer = false;  
    }
  }

  // getOptionalUpgradeQuantities(pu)
  // {
  //   let NumberList: any[] = [];
  //   let Numbers = {}
  //   for(var i = 0; i <= pu.quantityremaining; i++)
  //   {
  //     Numbers = { "name": i.toString(), value: i };
  //     NumberList.push(Numbers);
  //   }
  //   return NumberList;
  // }

  skipUpgrade()
  {
    if(this.SelectedPackage.packageabupgrades != null && this.SelectedPackage.packageabupgrades.length > 0)
    {
      let timedate = this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ this.globalTimeSlot.timeString + ":00.000Z"

      this.getOptionalUpgradeAvailability(this.SelectedPackage.packageabupgrades, timedate);

      this.setTab(Sections.OptionalUpgrades);
    }
    else if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
    {
      this.setTab(Sections.Customer);
    }
    else if(this.SelectedPackage.questionnaire != null)
    {
      this.setTab(Sections.BookingQuestions);
    }
    else
    {
      this.setTab(Sections.Extras);
    }

    this.busyService.idle();
  }

  doneUpgrade(SelectedUpgrade){

    //this.busyService.busy();

    SelectedUpgrade.upgrade.resources.forEach(pu => {
      pu.isupgrade = true;
      pu.packageupgradeid = SelectedUpgrade.packageupgradeid;
      this.NewBooking.resources.push(pu);
    });

    this.NewBooking.initialbooking = false;
    
    this.http.put<booking_returndata>(bmxurl + "/savebooking", this.NewBooking).subscribe(response => {
      this.httpResponse = (response as booking_returndata);     

      this.BookingResponse = this.httpResponse.data

        this.NewBooking = this.BookingResponse.bookingObj;

        this.validPaymentAmount = this.NewBooking.outstanding;
  
        this.paymentAmount = this.BookingResponse.bookingObj.total;
        let NumPeople: number = 0;
        this.NewBooking.resources[0].admissions.forEach(adm => {
          NumPeople += adm.noofpeople;
        });
  
        this.paymentAmount = this.BookingResponse.bookingObj.total;
        //this.OutstandingBalance = this.BookingResponse.bookingObj.outstanding;
        const formatter = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: this.CurrencySymbol});
  
        this.startTimes = null;
        this.startTimesFiltered = null;

        if(this.SelectedPackage.packageabupgrades != null && this.SelectedPackage.packageabupgrades.length > 0)
        {
          if(this.SelectedPackage.packageabupgrades != null && this.SelectedPackage.packageabupgrades.length > 0)
          {
            let timedate = this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ this.globalTimeSlot.timeString + ":00.000Z"

            this.getOptionalUpgradeAvailability(this.SelectedPackage.packageabupgrades, timedate);
          }
          
          this.setTab(Sections.OptionalUpgrades);
        }
        else if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
        {
          this.setTab(Sections.Customer);
        }
        else if(this.SelectedPackage.questionnaire != null)
        {
          this.setTab(Sections.BookingQuestions);
        }
        else
        {
          this.setTab(Sections.Extras);
        }

        this.UpgradeHeader = "You selected: " + SelectedUpgrade.upgrade.name;

        this.busyService.idle();

    }, error => {
      this.busyService.idle();
    })

  }

  doneOptionalUpgrade(){

    this.availablePackageOptionalUpgrades.forEach(pu => {
      if(pu.quantity > 0)
      {
        pu.upgrade.resources.forEach(res => {
          res.isupgrade = true;
          res.packageupgradeid = pu.packageupgradeid;
          res.quantity = pu.quantity;
          this.NewBooking.resources.push(res);
        });
      }
    });

    this.NewBooking.initialbooking = false;
    
    this.http.put<booking_returndata>(bmxurl + "/savebooking", this.NewBooking).subscribe(response => {
      this.httpResponse = (response as booking_returndata);     

      if(this.httpResponse.succeeded)
      {
        this.BookingResponse = this.httpResponse.data

        this.NewBooking = this.BookingResponse.bookingObj;

        this.validPaymentAmount = this.NewBooking.outstanding;

        this.paymentAmount = this.BookingResponse.bookingObj.total;
        let NumPeople: number = 0;
        this.NewBooking.resources[0].admissions.forEach(adm => {
          NumPeople += adm.noofpeople;
        });

        this.paymentAmount = this.BookingResponse.bookingObj.total;

        const formatter = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: this.CurrencySymbol});

        this.startTimes = null;
        this.startTimesFiltered = null;

        if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
        {
          this.setTab(Sections.Customer);
        }
        else if(this.SelectedPackage.questionnaire != null)
        {
          this.setTab(Sections.BookingQuestions);
        }
        else
        {
          this.setTab(Sections.Extras);
        }

        this.OptionalUpgradeHeader = "You selected: " + this.availablePackageOptionalUpgrades.map(upgrade => upgrade.name).join(", ");
      }
      else
      {
          this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages});
          this.busyService.idle();
      }

      this.busyService.idle();

    }, error => {
      this.busyService.idle();
    })

  }

  skipOptionalUpgrade()
  {
    if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
      {
        this.setTab(Sections.Customer);
      }
      else if(this.SelectedPackage.questionnaire != null)
      {
        this.setTab(Sections.BookingQuestions);
      }
      else
      {
        this.setTab(Sections.Extras);
      }

      this.busyService.idle();
  }

  removeDiscount()
  {
    this.busyService.busy();

    this.NewBooking.discounts = null;
    this.NewBooking.salestype = 0;

    this.http.put<booking_returndata>(bmxurl + "/savebooking", this.NewBooking).subscribe(response => {
      this.httpResponse = (response as booking_returndata);     

      this.BookingResponse = this.httpResponse.data

        this.NewBooking = this.BookingResponse.bookingObj;

        this.validPaymentAmount = this.NewBooking.outstanding;
  
        this.paymentAmount = this.BookingResponse.bookingObj.total;
        let NumPeople: number = 0;
        this.NewBooking.resources[0].admissions.forEach(adm => {
          NumPeople += adm.noofpeople;
        });
  
        this.paymentAmount = this.BookingResponse.bookingObj.total;
        //this.OutstandingBalance = this.BookingResponse.bookingObj.outstanding;
        const formatter = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: this.CurrencySymbol});
  
        this.startTimes = null;
        this.startTimesFiltered = null;
  
        this.messageService.add({ severity: 'success', summary: 'Discount Removed', detail: 'Your discount has been removed' });

        this.busyService.idle();

    }, error => {
      this.busyService.idle();
    })
  }

  doneExtras()
  {
    this.allQuestionsValid = true;

    this.packageExtras.forEach(element => {
      if(element.question != null)
      {
        if((element.question != "" && element.qty > 0) && (element.answer == null || element.answer == "")) 
        {
          this.allQuestionsValid = false;
        }
      }
      if (element.qty == 0)
      {
        element.answer = "";
      }
    });

    this.allVariableValuesValid = !this.packageExtras.some(element => this.variableValueMissing(element));

    if(this.allQuestionsValid && this.allVariableValuesValid)
    {
      this.ExtrasHeader = "You selected: ";

      let cost: number = 0;

      this.packageExtras.forEach(element => {
        if (element.qty == null)
          element.qty = 0;

        //A price is never sent as null. An ad hoc (variable value) extra starts with no
        //price so staff have to type one in, and one that was not chosen never gets one - but
        //the API will not take null, so an extra with no price goes as 0. One that was chosen
        //has already been made to have a value by the check above.
        if (element.price == null || isNaN(Number(element.price)))
          element.price = 0;
        
        if(element.qty > 0)
        {
          this.ExtrasHeader += element.name + " x " + element.qty + ", ";
          this.bookingExtras += element.name + " x " + element.qty + ", ";
          cost += element.qty * element.price;
        }
      });

      if(this.ExtrasHeader.length > 14)
      {
        this.ExtrasHeader = this.ExtrasHeader.substring(0, this.ExtrasHeader.length - 2);
      }
      else
      {
        this.ExtrasHeader = "You selected: No Extras";
      }
      this.NewBooking.extras = this.packageExtras;
      this.NewBooking.salestype = 0;
      
      //------------

      this.http.post<booking_returndata>(bmxurl + "/BookingExtra", this.NewBooking).subscribe(response => {
        this.httpResponse = (response as booking_returndata);      

        if(this.httpResponse.succeeded)
        {
          this.BookingResponse = this.httpResponse.data
          
          this.NewBooking = this.BookingResponse;

          const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: this.CurrencySymbol});

          this.paymentAmount = this.BookingResponse.total;
          this.makeABookingHeader = "Make a Booking - Sales Value: " + formatter.format(this.paymentAmount);
          this.bookingExtras = this.bookingExtras.substring(0, this.bookingExtras.length - 2);

          this.setTab(Sections.Customer);
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages});
          this.busyService.idle();
          
        }
      }, error => {
          this.messageService.add({severity:'error', summary:'Error', detail: error.message});
      })
    }
  }

  doneCustomer()
  {
    this.CustomerAllValid = true;

    if(this.ProvideMinimalPersonalData == "WALKIN")
    {
      if (this.lastName == "" || this.lastName == undefined || this.lastName == null) {
        this.CustomerAllValid = false;
        this.lastNameValid = false;
      }
      else {
        this.lastNameValid = true;
      }
    }
    else if(this.ProvideMinimalPersonalData)
    {
      if (this.firstName == "" || this.firstName == undefined || this.firstName == null) {
        this.CustomerAllValid = false;
        this.firstNameValid = false;
      }
      else {
        this.firstNameValid = true;
      }

      if (this.lastName == "") {
        this.CustomerAllValid = false;
        this.lastNameValid = false;
      }
      else {
        this.lastNameValid = true;
      }

      if (this.email == "") {
        if(this.ProvideMinimalPersonalData == "FULL" || this.ProvideMinimalPersonalData == "LIMITED")
        {
          this.CustomerAllValid = false;
          this.EmailValid = false;
        }
        else
        {
          this.EmailValid = true;
        }
      }
      else {
        this.EmailValid = true;
      }

      if (this.mobile == "") {
        if(this.ProvideMinimalPersonalData == "FULL" || this.ProvideMinimalPersonalData == "LIMITED")
        {
          this.CustomerAllValid = false;
          this.MobileValid = false;
        }
        else
        {
          this.MobileValid = true;
        }
      }
      else {
        this.MobileValid = true;
      }
    }
    else
    {
      if (this.firstName == "") {
        this.CustomerAllValid = false;
        this.firstNameValid = false;
      }
      else {
        this.firstNameValid = true;
      }

      if (this.lastName == "") {
        this.CustomerAllValid = false;
        this.lastNameValid = false;
      }
      else {
        this.lastNameValid = true;
      }

      if (this.address1 == "") {
        this.CustomerAllValid = false;
        this.Address1Valid = false;
      }
      else {
        this.Address1Valid = true;
      }

      if (this.town == "") {
        this.CustomerAllValid = false;
        this.TownValid = false;
      }
      else {
        this.TownValid = true;
      }

      if (this.postCode == "") {
        this.CustomerAllValid = false;
        this.PostCodeValid = false;
      }
      else {
        this.PostCodeValid = true;
      }

      if (this.email == "") {
        this.CustomerAllValid = false;
        this.EmailValid = false;
      }
      else {
        this.EmailValid = true;
      }

      if (this.mobile == "") {
        this.CustomerAllValid = false;
        this.MobileValid = false;
      }
      else {
        this.MobileValid = true;
      }
    }


    //Check for valid email and mobile

    if (this.email != "") {
      if (!this.validateEmail(this.email)) {
        this.CustomerAllValid = false;
        this.EmailFormatValid = false;
      }
      else {
        this.EmailFormatValid = true;
      }
    }

    if(this.mobile != ""){
      if (!this.validateMobile(this.mobile)) {
        this.CustomerAllValid = false;
        this.MobileFormatValid = false;
      }
      else {
        this.MobileFormatValid = true;
      }
    }

    if(this.CustomerAllValid == true)
    {
      this.CustomerHeader = "Customer: " + this.firstName + "  " + this.lastName;

      let newCustomer: Customer = {
        id: null,
        customerid: null,
        firstName: this.firstName,
        lastName: this.lastName,
        fullName: this.firstName + " " + this.lastName,
        address1: this.address1,
        address2: this.address2,
        townCity: this.town,
        postCode: this.postCode,
        email: this.email,
        mobile: this.mobile,
        dob: this.dob,
        venueId: this.VenueID,
        disabled: false,
        bookingid: null
      }

      this.NewBooking.customer = newCustomer;

      this.busyService.busy();
      this.savebooking();
      
      this.setTab(Sections.Notes);
    }
  }

  //Finishes a booking that needs no payment now. DoSummary on its own only draws the summary -
  //the booking stayed marked in progress on the server, which is what the daysheet stripes and
  //what abandoned bookings are cleared on. nodeposit tells the server no payment is due and keeps
  //the booking active.
  private completeWithoutPayment() {
    const previousPayments = this.NewBooking.payments;

    this.busyService.busy();

    this.http.get<any>(bmxurl + "nodeposit/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.busyService.idle();

      if(response?.succeeded == true)
      {
        //Use the booking the server sends back if there is one, otherwise the one already held.
        if(response.data?.bookingId)
          this.NewBooking = response.data;

        this.NewBooking.inProgress = false;
        this.BookingResponse = this.NewBooking;
        this.BookingPayments = this.NewBooking.payments ?? [];
        this.DoSummary(this.NewBooking);
      }
      else
      {
        this.failedToComplete(previousPayments, (response as any).messages?.[0]);
      }
    }, error => {
      this.busyService.idle();
      this.failedToComplete(previousPayments, error?.message);
    });
  }

  //Puts the booking back as it was and leaves staff on the payment page, where they can defer or
  //take a payment instead.
  private failedToComplete(previousPayments: any, reason: string) {
    this.NewBooking.payments = previousPayments;
    this.NewBooking.inProgress = true;

    this.messageService.add({severity:'error', summary:'Booking not completed', detail: 'The booking could not be completed' + (reason ? ': ' + reason : '.')});
    this.setTab(Sections.Payment);
  }

  doneNotes(){
    // Do deposit.
    //this.CalcDeposit(this.BookingResponse.bookingObj.totaladmission - this.DiscountTakenOff);

    //this.NewBooking.totalvenuedeposit = this.BookingResponse.bookingObj.totalvenuedeposit;
    //this.NewBooking.totalpublicdeposit  = this.BookingResponse.bookingObj.totalpublicdeposit ;

    if(this.NewBooking.PublicBooking)
    {
      this.validPaymentAmount = this.NewBooking.totalpublicdeposit - this.NewBooking.totalpayments;
    }
    else{
      this.validPaymentAmount = this.NewBooking.totalvenuedeposit - this.NewBooking.totalpayments;
    }

    //No deposit is due - the deposit is zero, or payments already made cover it - so there is
    //nothing for the payment page to take, and the booking is finished and shown as its summary.
    //Payment can still be taken later from the booking itself. An unknown deposit (not a number)
    //still goes to the payment page rather than being skipped.
    const noDepositDue = this.validPaymentAmount != null && !isNaN(this.validPaymentAmount) && this.validPaymentAmount <= 0;

    /*
      TEMPORARY, added 18/09/2026, to confirm the package really carries its deposit policy
      through PackageGroupList. policyType reading as undefined means it does not, and the
      guard above it can never fire. Out again once that has been seen working.
    */
    console.log("[deposit-diag] make a booking, payment decision", {
      policyType: this.depositPolicy()?.type,
      noDepositPolicy: this.noDepositPolicy(),
      publicBooking: this.NewBooking.PublicBooking,
      venueDeposit: this.NewBooking.totalvenuedeposit,
      publicDeposit: this.NewBooking.totalpublicdeposit,
      totalBookingFees: (this.NewBooking as any).totalbookingfees,
      outstanding: this.NewBooking.outstanding,
      willAskFor: this.validPaymentAmount
    });

    if(this.noDepositPolicy() || noDepositDue || this.NewBooking.outstanding <= 0)
    {
      this.completeWithoutPayment();
      return;
    }

    this.setTab(Sections.Payment);
  }

  //The deposit policy this booking is being taken under. Two are held on a package and which
  //one applies follows the same PublicBooking flag the deposit totals above are read with.
  private depositPolicy(): any {
    if (this.SelectedPackage == null) {
      return null;
    }

    return this.NewBooking?.PublicBooking
      ? this.SelectedPackage.publicDepositPolicy
      : this.SelectedPackage.venueDepositPolicy;
  }

  /*
    No Deposit means nothing is asked for when the booking is made - not a deposit, and not the
    booking fee either. It has to be read from the policy rather than from the figures, because
    the API returns the booking fee as the deposit total on these bookings (a fee of 5 comes
    back as a deposit of 5), and from the totals alone that is indistinguishable from a real
    deposit that happens to be the same amount.

    The money is not written off: the booking keeps its full outstanding balance and can be paid
    from the booking itself afterwards, exactly as a booking whose deposit was already covered.

    A package with no policy on it is left alone, so if this ever arrives without one the
    behaviour is the same as it was before.
  */
  private noDepositPolicy(): boolean {
    return this.depositPolicy()?.type == "NoDeposit";
  }

  // CalcDeposit(passedtotal: number){
  
  //   this.paymentAmount = passedtotal;
  //   let NumPeople: number = 0;
  //   this.NewBooking.resources[0].admissions.forEach(adm => {
  //     NumPeople += adm.noofpeople;
  //   });

  //   if(this.SelectedPackage.venueDepositPolicy == null)
  //   {
  //       this.paymentAmount = passedtotal;
  //   }
  //   else
  //   {
  //     let dp: cDepositpolicy = this.SelectedPackage.venueDepositPolicy;

  //     switch (dp.type)
  //     {
  //       case "Percentage":

  //         //Calculate date difference

  //         const oneDay = 24 * 60 * 60 * 1000;
  //         const creationDate: any = new Date();
  //         const bookingDate: any = new Date(this.NewBooking.startTime);

  //         const diffDays = Math.round(Math.abs((bookingDate - creationDate) / oneDay));

  //         if(diffDays < dp.alternativeamountthreshold)
  //         {
  //           this.validPaymentAmount = parseFloat(((this.paymentAmount * dp.alternativeamount) / 100).toFixed(2));
  //         }
  //         else
  //         {
  //           this.validPaymentAmount = parseFloat(((this.paymentAmount * dp.amount) / 100).toFixed(2));
  //         }
  //         break;
  //       case "PerPerson":
  //         this.validPaymentAmount = NumPeople * dp.amount;
  //         break;
  //       case "Fixed":
  //         this.validPaymentAmount = dp.amount;
  //         break;
  //       case "NoDeposit":
  //         this.validPaymentAmount = 0;
  //         break;
  //       default:
  //         this.validPaymentAmount = this.paymentAmount;
  //     }

  //     if(this.validPaymentAmount > this.paymentAmount)
  //     {
  //       this.validPaymentAmount = this.paymentAmount;
  //     }

  //     this.minimumDiscount = this.validPaymentAmount;
  //     this.maxPayment =  passedtotal;
  //   }

  //   //Add Booking Fee
  //   let BookingFeeValue = 0;
    
  //   if(localStorage.getItem("VenueBookingFee") != null)
  //   {
  //     let venueBookingFee: cBookingfee = (JSON.parse(localStorage.getItem("VenueBookingFee")) as cBookingfee)
     
  //     if (venueBookingFee.bfadminapply)
  //     {
  //       switch (venueBookingFee.bfadmintype)
  //       {
  //         case "PERPERSON":
  //           BookingFeeValue = venueBookingFee.bfadminfee * NumPeople;
  //           break;
  //         case "FIXED":
  //           BookingFeeValue =venueBookingFee.bfadminfee;
  //           break;
  //         case "PERCENTAGE":
  //           BookingFeeValue = parseFloat(((this.BookingResponse.bookingObj.total * venueBookingFee.bfadminfee) / 100).toFixed(2));
  //           break;
  //         default:
  //           BookingFeeValue = 0;
  //       }

  //       if (BookingFeeValue > venueBookingFee.bfadminmax && venueBookingFee.bfadminmax > 0)
  //         BookingFeeValue = venueBookingFee.bfadminmax

  //       if (BookingFeeValue < venueBookingFee.bfadminmin)
  //         BookingFeeValue = venueBookingFee.bfadminmin
  //     }
  //   }

  //   this.BookingFeeAdddedOn = BookingFeeValue;

  //   this.validPaymentAmount += BookingFeeValue

  //   this.MinimumValidPayment = this.validPaymentAmount;
  // }

  validateEmail(email){ 
    var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/; 
    return re.test(email); 
  }

  validateMobile(mobile){ 
    var re = /^\+?\d{1,3}?[\s\-]?(\(?\d{1,4}\)?[\s\-]?)?[\d\s\-]{5,}$/; 
    return re.test(mobile); 
  }

  deferPayment(){
    this.showDeferReason = true;
  }

  DoSummary(BookingSummary)
  {
    let admissionsText: string = "";
    let extrasText: string = "";

    BookingSummary.resources[0].admissions.forEach(adm => {
      if(adm.noofpeople > 0)
        admissionsText += adm.noofpeople + " x " +  adm.name + ", ";
    });

    if(admissionsText.length > 2)
    admissionsText = admissionsText.substring(0, admissionsText.length - 2);

    if(BookingSummary.extras != null)
    {
      if(BookingSummary.extras.length > 0)
      {
        BookingSummary.extras.forEach(element => {
          if(element.qty > 0)
          {
            if(element.answer != null && element.answer != "")
            {
              extrasText += element.name + " x " + element.qty + " (" + element.question + ": " + element.answer + "), ";
            }
            else
            {
              extrasText += element.name + " x " + element.qty + ", ";
            }
          }
        });
      }
    }

    if(extrasText.length > 2)
    {
      extrasText = extrasText.substring(0, extrasText.length - 2);
    }

    let CustomerName = "";
    let CustomerAddress1 = "";
    let CustomerAddress2 = "";
    let CustomerTownCity = "";
    let CustomerPostCode = "";
    let FullCustomer = "";

    CustomerName = BookingSummary.customer.fullName.trim();

    if (BookingSummary.customer.address1 != null && BookingSummary.customer.address1 != "") 
    {
      CustomerAddress1 = BookingSummary.customer.address1 = ", "
    }
    
    if (BookingSummary.customer.address2 != null && BookingSummary.customer.address2 != "") 
    {
      CustomerAddress2 = BookingSummary.customer.address2 = ", "
    }

    if (BookingSummary.customer.townCity != null && BookingSummary.customer.townCity != "") 
    {
      CustomerTownCity = BookingSummary.customer.townCity = ", "
    }

    if (BookingSummary.customer.postCode != null && BookingSummary.customer.postCode != "") 
    {
      CustomerPostCode = BookingSummary.customer.postCode = ", "
    }

    FullCustomer = CustomerName + CustomerAddress1 + CustomerAddress2 + CustomerTownCity + CustomerPostCode;

    let newBookingSummary:cBookingsummary = {
      Disabled: BookingSummary.disabled,
      bookingId: BookingSummary.bookingId,
      bookingIdHR: BookingSummary.bookingIdHR,
      admissions: admissionsText,
      startTime: BookingSummary.startTime,
      endTime: BookingSummary.endTime,
      name: BookingSummary.name,
      arrival: BookingSummary.arrival,
      guests: BookingSummary.guests,
      total: BookingSummary.total,
      outstanding: BookingSummary.outstanding,
      paid: Number(BookingSummary.total) - Number(BookingSummary.outstanding),
      totaldiscounts: Number(BookingSummary.totaldiscounts),
      totalbookingfees: Number(BookingSummary.totalbookingfees ?? BookingSummary.bookingfee ?? 0),
      bookingfee: Number(BookingSummary.bookingfee),
      customerName: BookingSummary.customer.fullName,
      customerAddress: FullCustomer,
      customerMobile: BookingSummary.customer.mobile,
      customerEmail:  BookingSummary.customer.email,
      packageName:  BookingSummary.packageName,
      publicBooking: BookingSummary.publicBooking,
      extras: extrasText,
      upgrade: BookingSummary.upgrade,
      upgradetext: BookingSummary.upgradetext,
      addontext: BookingSummary.addontext,
      itinerary: BookingSummary.itinerary,
      notes: BookingSummary.notes,
      totalbookingfee: BookingSummary.totalbookingfee,

    }

    this.BookingSummary = newBookingSummary;
    
    this.BookingComplete = true;
    this.showTimer = false;

    //Send Booking Notication
    this.http.get(bmxurl + "/bookingnotification/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.httpResponse = (response as any);
      const notificationsEnabled = localStorage.getItem("BookingNotification") == "true";
      if(this.httpResponse.succeeded)
      {
        if(notificationsEnabled)
        {
          this.messageService.add({severity:'success', summary:'Booking Notification', detail: "Booking notification sent successfully"});
        }
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Booking Notification Failed', detail: "Failed to send booking notification: " + this.httpResponse.messages[0]});
      }
    }, error => {
    })

  }

  //True when any extra on offer has a picture. The picture column is only drawn then, so a
  //package with no pictures keeps a plain list rather than a column of empty squares.
  get extrasHaveImages(): boolean {
    return (this.packageExtras ?? []).some(ext => !!ext.imageurl);
  }

  //The description is a required field on an extra, so it is often just the name typed again.
  //Shown only when it says something the name does not.
  showExtraDescription(product: cPackageExtra): boolean {
    const description = (product.description ?? "").trim().toLowerCase();
    const name = (product.name ?? "").trim().toLowerCase();

    return description != "" && description != name;
  }

  sumExtras(){
    this.TotalExtras = 0;

    this.packageExtras.forEach(element => {
      // if(element.allparticipants)
      // {
      //   element.qty = this.totalAdmissions;
      //   this.TotalExtras += Number(element.price) * Number(this.totalAdmissions);
      // }
      // else
      // {
        this.TotalExtras += Number(element.price) * Number(element.qty);
      //}
    });
  }

  addMembership()
  {
    if(this.MembershipID == "" || this.MembershipID == null)
    {
      this.messageService.add({severity:'warn', summary:'Membership ID', detail: "Please enter a Membership ID"});
      return;
    }
    else
    {
      this.busyService.busy();
      let retrievedmembershipid = "";
      this.http.get<any>(bmxurl + "getmembership/" + this.VenueID + "/" + this.MembershipID).subscribe(response => {

        if(response.succeeded == true)
        {
          retrievedmembershipid = response.data.salesid;
          this.MembershipPIN = response.data.membershippin;

          this.http.get(bmxurl + "/validatemembership/" + this.NewBooking.bookingId + "/" + retrievedmembershipid + "/" + this.MembershipPIN).subscribe(response => {
          this.httpResponse =  (response as any);

          if(this.httpResponse.succeeded)
            {
              this.NewBooking = this.httpResponse.data;

              this.CustomerHeader = "Customer: " +  this.firstName + "  " + this.lastName;

              const rawMessage = Array.isArray(this.httpResponse.messages) ? this.httpResponse.messages[0] : this.httpResponse.messages;
              if (typeof rawMessage === 'string' && rawMessage.startsWith('[FAILED]')) {
                this.messageService.add({severity:'error', summary:'Error', detail: rawMessage.substring('[FAILED]'.length).trim()});
              } else {
                this.messageService.add({severity:'success', summary:'Success', detail: this.httpResponse.messages});
              }

              if(this.NewBooking.PublicBooking)
              {
                this.paymentAmount = this.NewBooking.totalpublicdeposit;
              }
              else
              {
                this.paymentAmount = this.NewBooking.totalvenuedeposit;
              }

              if (this.NewBooking.customer != null)
              {
                this.CustomerHeader = "Customer: " + this.NewBooking.customer.firstName + "  " + this.NewBooking.customer.lastName;
              }
              else
              {
                this.messageService.add({severity:'error', summary:'Error', detail: "No customer found"});
              }

              this.setTab(Sections.Notes);
              this.busyService.idle();

            }
            else
            {
              this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages[0]});
              this.busyService.idle();
            }
          });
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: response.messages[0]});
          this.busyService.idle();
        }
      });
    }
  }
  // {
  //   if(this.MembershipID == "" || this.MembershipID == null)
  //   {
  //     this.messageService.add({severity:'warn', summary:'Membership ID', detail: "Please enter a Membership ID"});
  //     return;
  //   }
  //   else
  //   {
  //     this.busyService.busy();
  //     let retrievedmembershipid = "";
  //     this.http.get<any>(bmxurl + "getmembership/" + this.VenueID + "/" + this.MembershipID).subscribe(response => {
  //       if(response.succeeded == true)
  //       {
  //         retrievedmembershipid = response.data.membershipid;
  //         let membershipEnddate  = new Date(response.data.enddate);

  //         if(membershipEnddate < new Date())
  //         {
  //           this.messageService.add({severity:'error', summary:'Error', detail: "Membership has expired"});
  //           this.busyService.idle();
  //           return;
  //         }
  //         else
  //         {
  //           this.busyService.busy();
  //           this.NewBooking.membershipid =retrievedmembershipid;
  //           this.http.post<booking_returndata>(bmxurl + "/savebooking", this.NewBooking).subscribe(response => {
  //             this.httpResponse = (response as booking_returndata);      

  //             if(this.httpResponse.succeeded)
  //             {
  //               this.BookingResponse = this.httpResponse.data
                
  //               if(this.httpResponse.messages.length > 0)
  //               {
  //                 this.messageService.add({severity:'warn', summary:'Warning', detail: this.httpResponse.messages[0]});
  //               }
  //               else{
  //                 this.messageService.add({severity:'success', summary:'Success', detail: "Membership added"});
  //               }
                
  //               this.NewBooking = this.BookingResponse.bookingObj;

  //               let NumPeople: number = 0;
  //               this.NewBooking.resources[0].admissions.forEach(adm => {
  //                 NumPeople += adm.noofpeople;
  //               });
          
  //               this.paymentAmount = this.BookingResponse.bookingObj.total;

  //               if(this.NewBooking.PublicBooking)
  //               {
  //                 this.validPaymentAmount = this.NewBooking.totalpublicdeposit - this.NewBooking.totalpayments;
  //               }
  //               else{
  //                 this.validPaymentAmount = this.NewBooking.totalvenuedeposit - this.NewBooking.totalpayments;
  //               }
          
  //               const formatter = new Intl.NumberFormat('en-GB', {
  //                 style: 'currency',
  //                 currency: this.CurrencySymbol});
          
  //               this.makeABookingHeader = "Make a Booking - Sales Value: " + formatter.format(this.paymentAmount);

  //               if (this.NewBooking.customer != null)
  //               {
  //                 this.CustomerHeader = "Customer: " + this.NewBooking.customer.firstName + "  " + this.NewBooking.customer.lastName;
  //               }
  //               else
  //               {
  //                 this.messageService.add({severity:'error', summary:'Error', detail: "No customer found"});
  //               }

  //               this.setTab(Sections.Notes);
  //               this.busyService.idle();

  //             }
  //             else
  //             {
  //               this.getAvailability();
                
  //               this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages});
  //               this.busyService.idle();
  //             }
  //           }, error => {
  //         //             this.busyService.idle();
  //             this.messageService.add({severity:'error', summary:'Error', detail: error.message});
  //           })

  //           this.busyService.idle();
  //         }
  //       }
  //       else
  //       {
  //         this.messageService.add({severity:'error', summary:'Error', detail: response.messages});
  //         this.busyService.idle();
  //       }
      
  //       this.MembershipID = "";
  //     }, error => {
  //       this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred getting Membership'});
  //       this.busyService.idle();
  //       this.MembershipID = "";
  //     })
  //   }
  // }

  donePayment(paymentid: string, paymentname : string)
  {

    this.paymentButtonLocked = true;

    //Get number of people
    let NumPeople: number = 0;
    this.NewBooking.resources[0].admissions.forEach(adm => {
      NumPeople += adm.noofpeople;
    });

    this.AllValid = true;
    let AmountDue:number =this.validPaymentAmount;

    if (this.paymentAmount == null || (this.paymentAmount < 0)) {
      this.AllValid = false;
      this.paymentValueValid = false;
    }
    else {
      this.paymentValueValid = true;
      this.AllValid = true;
    }

    if(this.AllValid)
    {
      let newPayment: Payment = {
        id: null,
        PaymentId: null,
        BookingId: this.BookingResponse.bookingId,
        bookingIdHR: this.BookingResponse.bookingIdHR,
        method: paymentname,
        paymenttypeid: paymentid,
        amount: this.validPaymentAmount,
        paymentDate: new Date,
        disabled: false,
        venueid: this.VenueID,
        refunds: null,
        balance: this.validPaymentAmount,
        paymenttype: "booking",
        currency: this.CurrencySymbol,
        tillname: null
      }

      this.NewBooking.payments = [];
      this.NewBooking.payments.push(newPayment);
      this.NewBooking.inProgress = false;

      if(this.oldDepositValue == 0)
      {
        if(this.NewBooking.PublicBooking)
        {
          this.oldDepositValue = this.NewBooking.totalpublicdeposit;
        }
        else{
          this.oldDepositValue = this.NewBooking.totalvenuedeposit;
        }
      }

      const generalTerminalName = localStorage.getItem(`GeneralTerminalName_${this.VenueID}`) ?? '';
      const isCardPayment = paymentname.toLowerCase().includes('card');

      if (isCardPayment && generalTerminalName) {
        const terminalPayload = {
          venueid: this.VenueID,
          connectedAccountId: localStorage.getItem('RyftSubAccountID') ?? '',
          amount: Math.round(this.validPaymentAmount * 100),
          currency: this.CurrencySymbol.toLowerCase(),
          terminalId: generalTerminalName,
          method: 'BOOKING',
          identifier: this.NewBooking.bookingId ?? ''
        };

        this.initiateBookingTerminalPayment(terminalPayload);
        return;
      }

      this.http.post<booking_returndata>(bmxurl + "/Payment", this.NewBooking).subscribe(response => {
        this.BookingResponse = (response as booking_returndata).data
        
        if(response.succeeded == true)
        {
          setTimeout(() => {
            this.paymentButtonLocked = false;
          }, 1000);

          this.NewBooking = this.BookingResponse;
          this.BookingPayments = this.BookingResponse.payments;

          if(this.NewBooking.PublicBooking)
          {
            this.validPaymentAmount = this.NewBooking.totalpublicdeposit;
          }
          else{
            this.validPaymentAmount = this.NewBooking.totalvenuedeposit;
          }

          this.totalPayments = 0;
          this.BookingPayments.forEach(element => {
            this.totalPayments += element.amount;
          });

          if(this.NewBooking.totalpayments >= this.oldDepositValue)
          {
            this.DoSummary(this.BookingResponse);
          }
          else
          {
            this.NewBooking.totalvenuedeposit = this.BookingResponse.bookingObj.totalvenuedeposit;
            this.NewBooking.totalpublicdeposit  = this.BookingResponse.bookingObj.totalpublicdeposit ;
    
            if(this.NewBooking.PublicBooking)
            {
              this.validPaymentAmount = this.NewBooking.totalpublicdeposit;// - this.NewBooking.totalpayments;
            }
            else{
              this.validPaymentAmount = this.NewBooking.totalvenuedeposit;// - this.NewBooking.totalpayments;
            }
          }
        
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages});
          this.paymentButtonLocked = false;
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Error', detail: error.message});
        this.paymentButtonLocked = false;
      })
    }
  }  
  
  connectTerminalHubBooking(paymentIntentId: string): void {
    this.awaitingTerminalPayment = true;
    this.terminalPaymentResolved = false;

    this.terminalPollingIntervalId = setInterval(() => {
      this.ngZone.run(() => this.pollBookingForPayment());
    }, 10000);

    this.auth.getAccessTokenSilently().subscribe({
      next: (token) => {
        const hub = new HubConnectionBuilder()
          .withUrl(environment.servicestarget + '/venue/' + this.VenueID, {
            accessTokenFactory: () => token
          })
          .build();

        this.terminalHubConnection = hub;

        hub.on(paymentIntentId, (message: string) => {
          this.ngZone.run(() => {
            if (this.terminalPaymentResolved) return;
            this.terminalPaymentResolved = true;
            this.stopTerminalPolling();
            hub.stop();
            this.terminalHubConnection = null;
            this.awaitingTerminalPayment = false;

            if (message === 'succeeded') {
              this.messageService.add({ severity: 'success', summary: 'Payment Succeeded', detail: 'Card payment completed successfully.' });
              this.http.get<booking_returndata>(bmxurl + 'booking/' + this.VenueID + '/' + this.NewBooking.bookingId).subscribe(response => {
                if (response.succeeded) {
                  this.NewBooking = response.data;
                  this.BookingResponse = response.data;
                  this.BookingPayments = response.data.payments ?? [];
                  this.totalPayments = 0;
                  this.BookingPayments.forEach(p => { this.totalPayments += p.amount; });

                  if (this.NewBooking.totalpayments >= this.oldDepositValue) {
                    this.DoSummary(this.BookingResponse);
                  } else {
                    this.validPaymentAmount = this.NewBooking.PublicBooking
                      ? this.NewBooking.totalpublicdeposit
                      : this.NewBooking.totalvenuedeposit;
                  }
                }
                this.paymentButtonLocked = false;
              }, () => { this.paymentButtonLocked = false; });
            } else {
              this.paymentFailedMessage = message;
              this.showPaymentFailedDialog = true;
              this.paymentButtonLocked = false;
            }
          });
        });

        hub.start().catch(() => {
          this.terminalHubConnection = null;
        });
      },
      error: () => { /* polling continues */ }
    });
  }

  private pollBookingForPayment(): void {
    if (this.terminalPaymentResolved) {
      this.stopTerminalPolling();
      return;
    }

    this.http.get<booking_returndata>(bmxurl + 'booking/' + this.VenueID + '/' + this.NewBooking.bookingId).subscribe(response => {
      if (this.terminalPaymentResolved) return;

      if (response.succeeded && response.data.totalpayments >= this.oldDepositValue) {
        this.terminalPaymentResolved = true;
        this.stopTerminalPolling();
        if (this.terminalHubConnection) {
          this.terminalHubConnection.stop();
          this.terminalHubConnection = null;
        }
        this.awaitingTerminalPayment = false;

        this.NewBooking = response.data;
        this.BookingResponse = response.data;
        this.BookingPayments = response.data.payments ?? [];
        this.totalPayments = 0;
        this.BookingPayments.forEach(p => { this.totalPayments += p.amount; });

        this.messageService.add({ severity: 'success', summary: 'Payment Received', detail: 'Payment confirmed via terminal.' });
        this.DoSummary(this.BookingResponse);
        this.paymentButtonLocked = false;
      }
    });
  }

  private stopTerminalPolling(): void {
    if (this.terminalPollingIntervalId !== null) {
      clearInterval(this.terminalPollingIntervalId);
      this.terminalPollingIntervalId = null;
    }
  }

  private initiateBookingTerminalPayment(terminalPayload: any): void {
    this.http.post<any>(bmxurl + 'StripeTerminalPaymentInit', terminalPayload).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded) {
        const paymentIntentId: string = this.httpResponse.data?.paymentIntentId ?? this.httpResponse.data?.id ?? '';
        this.connectTerminalHubBooking(paymentIntentId);
      } else {
        const detail = this.httpResponse.messages?.[0] ?? 'Unknown error';
        if (detail.toLowerCase().includes('payment_intent in progress')) {
          this.pendingTerminalPayload = terminalPayload;
          this.pendingTerminalRetry = () => this.initiateBookingTerminalPayment(terminalPayload);
          this.showTerminalBusyDialog = true;
        } else {
          this.messageService.add({severity: 'error', summary: 'Terminal payment failed', detail});
          this.paymentButtonLocked = false;
        }
      }
    }, error => {
      this.messageService.add({severity: 'error', summary: 'Terminal payment failed', detail: error.message});
      this.paymentButtonLocked = false;
    });
  }

  waitForTerminal(): void {
    this.showTerminalBusyDialog = false;
  }

  clearTerminalAndRetryPayment(): void {
    const terminalId = this.pendingTerminalPayload?.terminalId ?? '';
    this.showTerminalBusyDialog = false;
    this.http.get<any>(bmxurl + 'StripeTerminalCancel/' + this.VenueID + '/' + terminalId).subscribe({
      complete: () => {
        this.pendingTerminalRetry?.();
      }
    });
  }

  cancelTerminalPayment(): void {
    this.terminalPaymentResolved = true;
    this.stopTerminalPolling();

    if (this.terminalHubConnection) {
      this.terminalHubConnection.stop();
      this.terminalHubConnection = null;
    }

    const terminalId = localStorage.getItem(`GeneralTerminalName_${this.VenueID}`) ?? '';
    this.http.get<any>(bmxurl + 'StripeTerminalCancel/' + this.VenueID + '/' + terminalId).subscribe({
      complete: () => {
        this.awaitingTerminalPayment = false;
        this.paymentButtonLocked = false;
      }
    });
  }

  sendSMSConfirmation(){
     this.http.get<customer>(bmxurl + "confirmation/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
       this.messageService.add({severity:'success', summary:'Success', detail:'SMS Message sent.'});
     }, error => {
       this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the SMS'});
     })
  }

  sendEmailConfirmation(){
     this.http.get<customer>(bmxurl + "confirmationemail/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
       this.messageService.add({severity:'success', summary:'Success', detail:'Email Message sent.'})
     }, error => {
       this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the Email'});
     })
  }

  // setTab(tabNumber: number)
  // {
  //   if(tabNumber == Sections.Date)
  //   {
  //     this.dateSelected = true;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = true;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = true;
  //     this.admissionsActive = true;
  //     this.partyroomsActive = true;
  //     this.timeActive = true;
  //     this.customerActive = true;
  //     this.paymentActive = true;
  //     this.extraActive = true;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = true;
  //     this.upgradeActive = true;
  //   }
  //   if(tabNumber == Sections.Package) 
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = true;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = true;
  //     this.partyroomsActive = true;
  //     this.timeActive = true;
  //     this.customerActive = true;
  //     this.paymentActive = true;
  //     this.extraActive = true;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = true;
  //     this.upgradeActive = true;
  //   }
  //   if(tabNumber == Sections.Admissions)
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = true;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = true;
  //     this.timeActive = true;
  //     this.customerActive = true;
  //     this.paymentActive = true;
  //     this.extraActive = true;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = true;
  //     this.upgradeActive = true;
  //   }
  //   if(tabNumber == Sections.Partyroom)
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = true;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = true;
  //     this.customerActive = true;
  //     this.paymentActive = true;
  //     this.extraActive = true;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = true;
  //     this.upgradeActive = true;
  //   }
  //   if(tabNumber == Sections.Time) 
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = true;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = false;
  //     this.customerActive = true;
  //     this.paymentActive = true;
  //     this.extraActive = true;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = true;
  //     this.upgradeActive = true;
  //   }
  //   if(tabNumber == Sections.Upgrades)
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = true;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = false;
  //     this.customerActive = true;
  //     this.paymentActive = true;
  //     this.extraActive = true;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = true;
  //     this.upgradeActive = false;


  //   }
  //   if(tabNumber == Sections.BookingQuestions) 
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = true;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = false;
  //     this.customerActive = true;
  //     this.paymentActive = true;
  //     this.extraActive = true;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = false;
  //     this.upgradeActive = false;
  //   }
  //   if(tabNumber == Sections.Customer)
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = true;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = false;
  //     this.customerActive = false;
  //     this.paymentActive = true;
  //     this.extraActive = false;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = false;
  //     this.upgradeActive = false;
  //   }
  //   if(tabNumber == Sections.Extras)
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = true;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = false;
  //     this.customerActive = true;
  //     this.extraActive = false;
  //     this.notesActive = true;
  //     this.paymentActive = true;
  //     this.bookingQuestionsActive = false;
  //     this.upgradeActive = false;
  //   }
  //   if(tabNumber == Sections.Notes)
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = true;
  //     this.paymentSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = false;
  //     this.customerActive = false;
  //     this.extraActive = false;
  //     this.notesActive = false;
  //     this.paymentActive = true;
  //     this.bookingQuestionsActive = false;
  //     this.upgradeActive = false;
  //   }
  //   if(tabNumber == Sections.Payment)
  //   {
  //     if(this.NewBooking.customer == null)
  //     {
  //       this.messageService.add({ severity: 'error', summary: 'Please enter a customer' });
  //       this.setTab(Sections.Customer);
  //       return;
  //     }

  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.paymentSelected = true;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = false;
  //     this.customerActive = false;
  //     this.extraActive = false;
  //     this.notesActive = false;
  //     this.paymentActive = false;
  //     this.bookingQuestionsActive = true;
  //     this.upgradeActive = false;
  //   }
  // }

  /*
    A booking the AI-Assistant prepared (BookingPrefillService). Make a Booking opens at its date
    and time - the bookingDate the assistant navigates with - and goes through the steps itself,
    each by that step's own Next: the package is picked once the day's packages arrive and its
    admissions and extras set; the time is booked by the same "book this time" path as above;
    the extras are saved; the customer staff saw on the card is attached, or a new one's details
    put in and saved; and the notes are written in. It stops on Notes, the last step before
    payment, for staff to check and go on - and anywhere a person is needed first: booking
    questions, upgrades, choosing a room, a time that has gone, details a new customer is
    missing. Each part is applied once. The price, deposit and payment are Make a Booking's own.
  */
  prefill: bookingprefill = null;
  private prefillDone: { [step: string]: boolean } = {};

  private prefillPackage() {
    if (this.prefill == null || this.prefillDone["package"]) {
      return;
    }

    this.prefillDone["package"] = true;

    let found: any = null;
    (this.packageGroups ?? []).forEach(group => (group.packages ?? []).forEach((pkg: any) => {
      if (found == null && pkg.packageId == this.prefill.packageId) {
        found = pkg;
      }
    }));

    if (found == null) {
      this.messageService.add({severity:'warn', summary:'AI-Assistant', detail: this.prefill.packageName + ' cannot be booked on this date any more, so it has not been picked. Choose a package.'});
      return;
    }

    this.donePackage(found);

    (this.SelectedAdmissions ?? []).forEach((adm: any) => {
      const wanted = this.prefill.admissions.find(item => item.admissionid == adm.admissionid);

      if (wanted != null) {
        adm.noofpeople = wanted.count;
      }
    });

    this.sumAdmissions();

    (this.packageExtras ?? []).forEach((ext: any) => {
      const wanted = this.prefill.extras.find(item => item.extraid == ext.extraId);

      if (wanted != null && !this.isVariableValueExtra(ext)) {
        ext.qty = wanted.qty;
      }
    });

    this.sumExtras();

    //On to the time, as the Admissions step's Next does - which books the time asked for as soon
    //as it is found free. Left on Admissions for staff if the numbers do not fit the package.
    if (this.totalAdmissionInRange) {
      setTimeout(() => this.doneAdmissions());
    }
  }

  private applyPrefill(tabNumber: number) {
    if (this.prefill == null) {
      return;
    }

    //Each step's own Next, run once the step has opened and whatever opened it has finished.
    //Each one checks the step as it does when staff press it, and stays put for staff if
    //something is missing.
    if (tabNumber == Sections.Extras && !this.prefillDone["extras"]) {
      this.prefillDone["extras"] = true;
      setTimeout(() => this.doneExtras());
    }

    if (tabNumber == Sections.Customer && !this.prefillDone["customer"]) {
      this.prefillDone["customer"] = true;
      const customer = this.prefill.customer;

      if (customer.customerid != null) {
        //The customer staff saw on the assistant's card, looked up again and attached as picking
        //them from the search does. If they cannot be found, the search is left showing.
        this.searchCriteria = (customer.email ?? "") != "" ? customer.email : (customer.firstName + " " + customer.lastName).trim();
        this.http.get(bmxurl + "customer/search/" + this.VenueID + "/" + encodeURIComponent(this.searchCriteria)).subscribe(response => {
          const rows: any[] = (response as any)?.data ?? [];
          const match = rows.find(row => row.customerid == customer.customerid);

          if (match != null) {
            this.addselectedCustomer(match);
          }
          else {
            this.customersResult = response as any;
          }
        }, error => {
          this.searchCustomer();
        });
      }
      else {
        this.firstName = customer.firstName ?? "";
        this.lastName = customer.lastName ?? "";
        this.email = customer.email ?? "";
        this.mobile = customer.mobile ?? "";
        this.address1 = customer.address1 ?? "";
        this.address2 = customer.address2 ?? "";
        this.town = customer.townCity ?? "";
        this.postCode = customer.postCode ?? "";
        this.ShowCustomerDetails = true;
        setTimeout(() => this.doneCustomer());
      }
    }

    if (tabNumber == Sections.Notes && !this.prefillDone["notes"]) {
      this.prefillDone["notes"] = true;

      if ((this.prefill.notes ?? "") != "" && (this.NewBooking.notes ?? "") == "") {
        this.NewBooking.notes = this.prefill.notes;
      }
    }
  }

  setTab(tabNumber: number)
  {
    if(tabNumber == Sections.Date)
    {
      this.dateSelected = true;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = true;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = true;
      this.admissionsActive = true;
      this.partyroomsActive = true;
      this.timeActive = true;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = true;
      this.upgradeActive = true;
      this.optionalUpgradeActive = true;
    }
    if(tabNumber == Sections.Package) 
    {
      this.dateSelected = false;
      this.packageSelected = true;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = true;
      this.partyroomsActive = true;
      this.timeActive = true;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = true;
      this.upgradeActive = true;
      this.optionalUpgradeActive = true;
    }
    if(tabNumber == Sections.Admissions)
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = true;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = true;
      this.timeActive = true;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = true;
      this.upgradeActive = true;
      this.optionalUpgradeActive = true;
    }
    if(tabNumber == Sections.Partyroom)
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = true;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = true;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = true;
      this.upgradeActive = true;
      this.optionalUpgradeActive = true;
    }
    if(tabNumber == Sections.Time) 
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = true;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = true;
      this.upgradeActive = true;
      this.optionalUpgradeActive = true;
    }
    if(tabNumber == Sections.Upgrades)
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = true;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = true;
      this.upgradeActive = false;
      this.optionalUpgradeActive = false;


    }
    if(tabNumber == Sections.OptionalUpgrades)
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = true;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = true;
      this.upgradeActive = false;
      this.optionalUpgradeActive = false;


    }
    if(tabNumber == Sections.BookingQuestions) 
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = true;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = false;
      this.upgradeActive = false;
      this.optionalUpgradeActive = true;
    }
    if(tabNumber == Sections.Customer)
    {
      if(this.qbook == "true"){
        this.doWalkin()
      }

      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = true;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = false;
      this.paymentActive = true;
      this.extraActive = false;
      this.notesActive = true;
      this.bookingQuestionsActive = false;
      this.upgradeActive = false;
      this.optionalUpgradeActive = true;
    }
    if(tabNumber == Sections.Extras)
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = true;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = true;
      this.extraActive = false;
      this.notesActive = true;
      this.paymentActive = true;
      this.bookingQuestionsActive = false;
      this.upgradeActive = false;
      this.optionalUpgradeActive = false;
    }
    if(tabNumber == Sections.Notes)
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.extraSelected = false;
      this.notesSelected = true;
      this.paymentSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = false;
      this.extraActive = false;
      this.notesActive = false;
      this.paymentActive = true;
      this.bookingQuestionsActive = false;
      this.upgradeActive = false;
      this.optionalUpgradeActive = false;
    }
    if(tabNumber == Sections.Payment)
    {
      if(this.NewBooking.customer == null)
      {
        this.messageService.add({ severity: 'error', summary: 'Please enter a customer' });
        this.setTab(Sections.Customer);
        return;
      }

      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.paymentSelected = true;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = false;
      this.extraActive = false;
      this.notesActive = false;
      this.paymentActive = false;
      this.bookingQuestionsActive = true;
      this.upgradeActive = false;
      this.optionalUpgradeActive = false;
    }

    this.applyPrefill(tabNumber);
  }

  returnHome(){

    this.bookSlot(null);
    this.AbandonBooking();

    this.setTab(Sections.Date);
    this.BookingPayments = [];
    this.totalPayments = 0;

    this.checked = [];

    this.BookingComplete = false;

    this.PackageHeader = "Select a Package";
    this.CalendarHeader = "Select a Date";
    this.AdmissionHeader = "Select your Admissions";
    this.TimeHeader = "Select a Time";
    this.CustomerHeader = "Create a Customer";
    this.PaymentHeader = "Add a Payment";
    this.ExtrasHeader = "Select Extras";

    this.startTimes = null;
    this.startTimesFiltered = null;

    this.SelectedPackage = null;
    this.SelectedDate = null;

    this.firstName = "";
    this.lastName = "";
    this.address1 = "";
    this.address2 = "";
    this.town = "";
    this.postCode = "";
    this.email = "";
    this.mobile = "";
    this.searchCriteria = "";
    this.customersResult = null;
    this.ShowCustomerDetails = false;

    this.selectedPayment = null;
    this.packageExtras = null;
    this.paymentAmount = 0;
    this.makeABookingHeader = "Make a Booking";
    this.NewBooking = {} as booking;
    //Finished with, or the next booking's availability ignores the last one - see getUpgradeAvailability.
    this.AvailabilityReq = {} as AvailabilityReq;
    this.customerSelectedResources = [];
    this.SelectedResources = [];

    this.MinimumValidPayment = 0;
    this.BookingTimeElasped = false;

    this.restartTimer('');
  }

  returnQHome(){
    this.bookSlot(null);
    this.AbandonBooking();

    this.setTab(Sections.Date);
    this.BookingPayments = [];
    this.totalPayments = 0;

    this.checked = [];

    this.BookingComplete = false;

    this.PackageHeader = "Select a Package";
    this.CalendarHeader = "Select a Date";
    this.AdmissionHeader = "Select your Admissions";
    this.TimeHeader = "Select a Time";
    this.CustomerHeader = "Create a Customer";
    this.PaymentHeader = "Add a Payment";
    this.ExtrasHeader = "Select Extras";
    this.SelectedPackage = null;

    this.startTimes = null;
    this.startTimesFiltered = null;

    this.SelectedPackage = null;
    this.SelectedDate = null;

    this.firstName = "";
    this.lastName = "";
    this.address1 = "";
    this.address2 = "";
    this.town = "";
    this.postCode = "";
    this.email = "";
    this.mobile = "";
    this.searchCriteria = "";
    this.customersResult = null;
    this.ShowCustomerDetails = false;

    this.selectedPayment = null;
    this.packageExtras = null;
    this.paymentAmount = 0;
    this.makeABookingHeader = "Make a Booking";
    this.NewBooking = {} as booking;
    //Finished with, or the next booking's availability ignores the last one - see getUpgradeAvailability.
    this.AvailabilityReq = {} as AvailabilityReq;
    this.customerSelectedResources = [];
    this.SelectedResources = [];

    this.MinimumValidPayment = 0;
    this.BookingTimeElasped = false;

    this.restartTimer('');

    this.SelectedDate = new Date();
    this.doneDate();
    this.setTab(Sections.Package);
  }
  
  AbandonBooking() {
    if (this.NewBooking != null && this.NewBooking.bookingId != null) {
      if (this.NewBooking.bookingId != null) {
        let abandonBooking: any = {
          bookingid: this.NewBooking.bookingId,
          jwt: null
        };
        //Booking Exists, abandon it
        this.http.post(bmxurl + "abandonbooking/" + this.VenueID, abandonBooking).subscribe(response => {
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Failure', detail: 'Failed to abandon booking.' });
        });
      }
    }
  }

  getAvailability(){
    this.busyService.busy();
    let totalNoOfPeople: number = 0;

    this.AvailabilityReq.Admissions = [] as admission[];

     this.SelectedAdmissions.forEach(adm => {
    
       this.AvailabilityReq.Admissions.push(adm);
      //totalNoOfPeople += adm.noofpeople;
      
    });

    this.AvailabilityReq.packageId = this.SelectedPackage.packageId;
    //AvailabilityReq.NoOfPeople =  totalNoOfPeople;
    this.AvailabilityReq.venueid = this.VenueID;
    this.AvailabilityReq.StartTime =  this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1) + "-" +  this.SelectedDate.getDate() + "T00:00:00.000Z";
    this.AvailabilityReq.DiagnosticMode = true;
    this.AvailabilityReq.Resources = this.customerSelectedResources;
    this.AvailabilityReq.useintervalavailability = this.UseIntervalAvailability;

    this.http.post<availabletimes_returndata>(bmxurl + "/Availability", this.AvailabilityReq).subscribe(response => {
      if((response as availabletimes_returndata).succeeded)
      {
        this.startTimes =(response as availabletimes_returndata).data
        let found: Boolean = false;

      this.startTimesFiltered = [];
        this.startTimes.forEach(element => {
          if(element.timeAvailable)
          {
            this.startTimesFiltered.forEach(innerelement => {
              if(innerelement.time == element.time)
                found = true;
            });

            if(!found)
            {
              this.startTimesFiltered.push(element);
            }
            found = false;
          }
        });

        if(this.timetobetried != "")
        {
          let timefound = false;

          this.startTimes.forEach(element => {
            //let timetocheck = new Date(element.time);
            //let sTimetocheck = timetocheck.getHours().toString().padStart(2, '0') + ":" + timetocheck.getMinutes().toString().padStart(2, '0');
            
            if(element.timeString == this.timetobetried && element.timeAvailable)
            {
              timefound = true;
              this.timetobetried = "";
              this.bookSlot(element);
            }
          });

          if(!timefound){
            this.messageService.add({severity:'error', summary:'Error', detail: "The time you selected in 'Book this time' is no longer available. Please select another time."});
          }
        }

        if (this.startTimesFiltered.length > 0) {
          this.pendingScrollToFirstTime = true;
        }

        this.busyService.idle();
    }
    else
    {
      this.messageService.add({severity:'error', summary:'Error', detail: (response as availabletimes_returndata).messages[0]});
      this.busyService.idle();
    }

    }, error => {
      this.busyService.idle();
  })
  this.busyService.idle();

  }

  getOptionalUpgradeAvailability(packageabupgrades: packageabupgrade[], startTime: string)
  {

    this.availablePackageOptionalUpgrades = [];
   // this.busyService.busy();

    let totalNoOfPeople: number = 0;

    this.AvailabilityReq.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
       this.AvailabilityReq.Admissions.push(adm);
    });

    this.AvailabilityReq.packageId = this.SelectedPackage.packageId;
    this.AvailabilityReq.venueid = this.VenueID;
    this.AvailabilityReq.DiagnosticMode = true;
    this.AvailabilityReq.StartTime = startTime;//this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ startTime + ":00.000Z";
    this.AvailabilityReq.IgnoreExistingBooking = true;
    this.AvailabilityReq.ExistingBookingID = this.NewBooking.bookingId;
    this.AvailabilityReq.useintervalavailability = this.UseIntervalAvailability;

    //First Upgrade
    if(packageabupgrades.length > 0)
    {  
      this.AvailabilityReq.Resources = [];//JSON.parse(JSON.stringify(this.customerSelectedResources)); 
      packageabupgrades[0].upgrade.resources.forEach(res => { 
        this.AvailabilityReq.Resources.push(res);
      });
      this.http.post<any>(bmxurl + "/Availability", this.AvailabilityReq).subscribe(response => {       
        if((response as any).succeeded)
        {
         if(response.data.length > 0 && response.data[0].timeAvailable)
         {
          packageabupgrades[0].upgrade.resources = [];

          response.data[0].resources.forEach(res => {
            if(res.isupgrade == true)   
            {
              packageabupgrades[0].quantityremaining = response.data[0].quantityRemaining;
              packageabupgrades[0].upgrade.resources.push(res);
            }
          });
            
          this.availablePackageOptionalUpgrades.push(packageabupgrades[0]);
          this.optioanlUpgradeavaibilitydone[0] = true;
          this.showOptionalUpgradesScreen = true;

          this.availablePackageOptionalUpgrades = this.availablePackageOptionalUpgrades.sort((a, b) => (a.order > b.order) ? 1 : -1);

          this.globalService.setOptionalUpgradesComplete(this.optioanlUpgradeavaibilitydone);
          this.globalService.showOptionalUpgradeScreen(this.showOptionalUpgradesScreen);

          this.setTab(Sections.OptionalUpgrades);
            
          this.busyService.idle();
         }
         else
         {
            this.busyService.idle();
            this.upgradeavaibilitydone[0] = true;
            this.showTheUpgradeScreen[0] = false;

            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

            if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
            {
              this.setTab(Sections.Customer);
            }
            else if(this.SelectedPackage.questionnaire != null)
            {
              this.setTab(Sections.BookingQuestions);
            }
            else
            {
              this.setTab(Sections.Extras);
            }
         }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: (response as availabletimes_returndata).messages[0]});
          this.busyService.idle();
        }
      }, error => {
        this.busyService.idle();
      });
    }
    else
    {
      if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
      {
        this.setTab(Sections.Customer);
      }
      else if(this.SelectedPackage.questionnaire != null)
      {
        this.setTab(Sections.BookingQuestions);
      }
      else
      {
        this.setTab(Sections.Extras);
      }

      this.upgradeavaibilitydone[0] = true;
      this.upgradeavaibilitydone[1] = true;
      this.upgradeavaibilitydone[2] = true;
      
      this.showTheUpgradeScreen[0] = false;
      this.showTheUpgradeScreen[1] = false;
      this.showTheUpgradeScreen[2] = false;

       this.globalService.setOptionalUpgradesComplete(this.optioanlUpgradeavaibilitydone);
      this.globalService.showOptionalUpgradeScreen(this.showOptionalUpgradesScreen);

      this.showUpgrade = false;
      this.busyService.idle();
    }

    //Second Upgrade

    this.AvailabilityReq2.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
       this.AvailabilityReq2.Admissions.push(adm);
    });

    this.AvailabilityReq2.packageId = this.SelectedPackage.packageId;
    this.AvailabilityReq2.venueid = this.VenueID;
    this.AvailabilityReq2.DiagnosticMode = true;
    this.AvailabilityReq2.StartTime = startTime;//this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ startTime + ":00.000Z";
    this.AvailabilityReq2.IgnoreExistingBooking = true;
    this.AvailabilityReq2.ExistingBookingID = this.NewBooking.bookingId;
    this.AvailabilityReq2.useintervalavailability = this.UseIntervalAvailability;


    if(packageabupgrades.length > 1)
    {  
      this.AvailabilityReq2.Resources = JSON.parse(JSON.stringify(this.customerSelectedResources)); 
      packageabupgrades[1].upgrade.resources.forEach(res1 => { 
        this.AvailabilityReq2.Resources.push(res1);
      });
      this.http.post<any>(bmxurl + "/Availability", this.AvailabilityReq2).subscribe(response => {       
        if((response as any).succeeded)
        {
          if(response.data.length > 0 && response.data[0].timeAvailable)
          {

            packageabupgrades[1].upgrade.resources = [];
  
            response.data[0].resources.forEach(res => {
              if(res.isupgrade == true)   
              {
                packageabupgrades[1].quantityremaining = response.data[0].quantityRemaining;
                packageabupgrades[1].upgrade.resources.push(res);
              }
            });
            
            // if(packageabupgrades[1].optional)
            // {
              this.availablePackageOptionalUpgrades.push(packageabupgrades[1]);

              this.availablePackageOptionalUpgrades = this.availablePackageOptionalUpgrades.sort((a, b) => (a.order > b.order) ? 1 : -1);

              this.upgradeavaibilitydone[1] = true;
              this.showTheUpgradeScreen[1] = true;
             
              this.globalService.setUpgradesComplete(this.optioanlUpgradeavaibilitydone);
              this.globalService.showUpgradeScreen(this.showOptionalUpgradesScreen);

              this.setTab(Sections.OptionalUpgrades);
            //}

            this.busyService.idle();
          }
          else
          {
            this.optioanlUpgradeavaibilitydone[1] = true;
            this.showOptionalUpgradesScreen = false;

            this.globalService.setOptionalUpgradesComplete(this.optioanlUpgradeavaibilitydone);
            this.globalService.showOptionalUpgradeScreen(this.showOptionalUpgradesScreen);

            this.busyService.idle();
          }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: (response as availabletimes_returndata).messages[0]});
          this.busyService.idle();
        }
      }, error => {
        this.busyService.idle();
      });
    }
    else
    {
      this.upgradeavaibilitydone[1] = true;
    }

    //Third Upgrade

    this.AvailabilityReq3.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
       this.AvailabilityReq3.Admissions.push(adm);
    });

    this.AvailabilityReq3.packageId = this.SelectedPackage.packageId;
    this.AvailabilityReq3.venueid = this.VenueID;
    this.AvailabilityReq3.DiagnosticMode = true;
    this.AvailabilityReq3.StartTime = startTime;//this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ startTime + ":00.000Z";
    this.AvailabilityReq3.IgnoreExistingBooking = true;
    this.AvailabilityReq3.ExistingBookingID = this.NewBooking.bookingId;
    this.AvailabilityReq3.useintervalavailability = this.UseIntervalAvailability;

    if(packageabupgrades.length > 2)
    {  
      this.AvailabilityReq3.Resources = JSON.parse(JSON.stringify(this.customerSelectedResources)); 
      packageabupgrades[2].upgrade.resources.forEach(res2 => { 
        this.AvailabilityReq3.Resources.push(res2);
      });
      this.http.post<any>(bmxurl + "/Availability", this.AvailabilityReq3).subscribe(response => {       
        if((response as any).succeeded)
        {
          if(response.data.length > 0 && response.data[0].timeAvailable)
          {

            packageabupgrades[2].upgrade.resources = [];
  
            response.data[0].resources.forEach(res => {
              if(res.isupgrade == true)   
              {
                packageabupgrades[2].quantityremaining = response.data[0].quantityRemaining;
                packageabupgrades[2].upgrade.resources.push(res);
              }
            });

            // if(packageabupgrades[2].optional)
            // {
              this.availablePackageOptionalUpgrades.push(packageabupgrades[2]);

              this.availablePackageOptionalUpgrades = this.availablePackageOptionalUpgrades.sort((a, b) => (a.order > b.order) ? 1 : -1);

              this.optioanlUpgradeavaibilitydone[2] = true;
              this.showOptionalUpgradesScreen = false;

              this.globalService.setUpgradesComplete(this.optioanlUpgradeavaibilitydone);
              this.globalService.showUpgradeScreen(this.showOptionalUpgradesScreen);

              this.setTab(Sections.OptionalUpgrades);
            //}

            this.busyService.idle();
          }
          else
          {
            this.upgradeavaibilitydone[2] = true;
            this.showTheUpgradeScreen[2] = false;

            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

            this.busyService.idle();
          }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: (response as availabletimes_returndata).messages[0]});
          this.busyService.idle();
        }
      }, error => {
        this.busyService.idle();
      });
    }
    else
    {
      this.upgradeavaibilitydone[2] = true;
    }
  }

  getUpgradeAvailability(packageupgrades: packageupgrade[], startTime: string)
  {

    this.availablePackageUpgrades = [];

   // this.busyService.busy();

    let totalNoOfPeople: number = 0;

    this.AvailabilityReq.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
       this.AvailabilityReq.Admissions.push(adm);
    });

    this.AvailabilityReq.packageId = this.SelectedPackage.packageId;
    this.AvailabilityReq.venueid = this.VenueID;
    this.AvailabilityReq.DiagnosticMode = true;
    this.AvailabilityReq.StartTime = startTime;//this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ startTime + ":00.000Z";
    this.AvailabilityReq.IgnoreExistingBooking = true;
    this.AvailabilityReq.ExistingBookingID = this.NewBooking.bookingId;
    this.AvailabilityReq.useintervalavailability = this.UseIntervalAvailability;

    //First Upgrade
    if(packageupgrades.length > 0)
    {  
      this.AvailabilityReq.Resources = JSON.parse(JSON.stringify(this.customerSelectedResources)); 
      packageupgrades[0].upgrade.resources.forEach(res => { 
        this.AvailabilityReq.Resources.push(res);
      });
      this.http.post<availabletimes_returndata>(bmxurl + "/Availability", this.AvailabilityReq).subscribe(response => {       
        if((response as availabletimes_returndata).succeeded)
        {
         if(response.data.length > 0 && response.data[0].timeAvailable)
         {
          packageupgrades[0].upgrade.resources = [];

          response.data[0].resources.forEach(res => {
            if(res.isupgrade == true)   
            {
              packageupgrades[0].upgrade.resources.push(res);
            }
          });
            
            this.availablePackageUpgrades.push(packageupgrades[0]);
            this.upgradeavaibilitydone[0] = true;
            this.showTheUpgradeScreen[0] = true;

            this.availablePackageUpgrades = this.availablePackageUpgrades.sort((a, b) => (a.order > b.order) ? 1 : -1);

            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

            this.setTab(Sections.Upgrades);
            
            this.busyService.idle();
         }
         else
         {
            this.busyService.idle();
            //this.availablePackageUpgrades.push(packageupgrades[0]);
            this.upgradeavaibilitydone[0] = true;
            this.showTheUpgradeScreen[0] = false;

            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

            if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
            {
              this.setTab(Sections.Customer);
            }
            else if(this.SelectedPackage.questionnaire != null)
            {
              this.setTab(Sections.BookingQuestions);
            }
            else
            {
              this.setTab(Sections.Extras);
            }
         }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: (response as availabletimes_returndata).messages[0]});
          this.busyService.idle();
        }
      }, error => {
        this.busyService.idle();
      });
    }
    else
    {
      if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
      {
        this.setTab(Sections.Customer);
      }
      else if(this.SelectedPackage.questionnaire != null)
      {
        this.setTab(Sections.BookingQuestions);
      }
      else
      {
        this.setTab(Sections.Extras);
      }

      this.upgradeavaibilitydone[0] = true;
      this.upgradeavaibilitydone[1] = true;
      this.upgradeavaibilitydone[2] = true;
      
      this.showTheUpgradeScreen[0] = false;
      this.showTheUpgradeScreen[1] = false;
      this.showTheUpgradeScreen[2] = false;

      this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
      this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

      this.showUpgrade = false;
      this.busyService.idle();
    }

    //Second Upgrade

    this.AvailabilityReq2.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
       this.AvailabilityReq2.Admissions.push(adm);
    });

    this.AvailabilityReq2.packageId = this.SelectedPackage.packageId;
    this.AvailabilityReq2.venueid = this.VenueID;
    this.AvailabilityReq2.DiagnosticMode = true;
    this.AvailabilityReq2.StartTime = startTime;//this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ startTime + ":00.000Z";
    this.AvailabilityReq2.IgnoreExistingBooking = true;
    this.AvailabilityReq2.ExistingBookingID = this.NewBooking.bookingId;
    this.AvailabilityReq2.useintervalavailability = this.UseIntervalAvailability;


    if(packageupgrades.length > 1)
    {  
      this.AvailabilityReq2.Resources = JSON.parse(JSON.stringify(this.customerSelectedResources)); 
      packageupgrades[1].upgrade.resources.forEach(res1 => { 
        this.AvailabilityReq2.Resources.push(res1);
      });
      this.http.post<availabletimes_returndata>(bmxurl + "/Availability", this.AvailabilityReq2).subscribe(response => {       
        if((response as availabletimes_returndata).succeeded)
        {
          if(response.data.length > 0 && response.data[0].timeAvailable)
          {

            packageupgrades[1].upgrade.resources = [];
  
            response.data[0].resources.forEach(res => {
              if(res.isupgrade == true)   
              {
                packageupgrades[1].upgrade.resources.push(res);
              }
            });
            
            this.availablePackageUpgrades.push(packageupgrades[1]);

            this.availablePackageUpgrades = this.availablePackageUpgrades.sort((a, b) => (a.order > b.order) ? 1 : -1);

            this.upgradeavaibilitydone[1] = true;
            this.showTheUpgradeScreen[1] = true;
            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);
            
            this.setTab(Sections.Upgrades);

            this.busyService.idle();
          }
          else
          {
            this.upgradeavaibilitydone[1] = true;
            this.showTheUpgradeScreen[1] = false;

            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

            this.busyService.idle();
          }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: (response as availabletimes_returndata).messages[0]});
          this.busyService.idle();
        }
      }, error => {
        this.busyService.idle();
      });
    }
    else
    {
      this.upgradeavaibilitydone[1] = true;
    }

    //Third Upgrade

    this.AvailabilityReq3.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
       this.AvailabilityReq3.Admissions.push(adm);
    });

    this.AvailabilityReq3.packageId = this.SelectedPackage.packageId;
    this.AvailabilityReq3.venueid = this.VenueID;
    this.AvailabilityReq3.DiagnosticMode = true;
    this.AvailabilityReq3.StartTime = startTime;//this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ startTime + ":00.000Z";
    this.AvailabilityReq3.IgnoreExistingBooking = true;
    this.AvailabilityReq3.ExistingBookingID = this.NewBooking.bookingId;
    this.AvailabilityReq3.useintervalavailability = this.UseIntervalAvailability;

    if(packageupgrades.length > 2)
    {  
      this.AvailabilityReq3.Resources = JSON.parse(JSON.stringify(this.customerSelectedResources)); 
      packageupgrades[2].upgrade.resources.forEach(res2 => { 
        this.AvailabilityReq3.Resources.push(res2);
      });
      this.http.post<availabletimes_returndata>(bmxurl + "/Availability", this.AvailabilityReq3).subscribe(response => {       
        if((response as availabletimes_returndata).succeeded)
        {
          if(response.data.length > 0 && response.data[0].timeAvailable)
          {

            packageupgrades[2].upgrade.resources = [];
  
            response.data[0].resources.forEach(res => {
              if(res.isupgrade == true)   
              {
                packageupgrades[2].upgrade.resources.push(res);
              }
            });

            this.availablePackageUpgrades.push(packageupgrades[2]);

            this.availablePackageUpgrades = this.availablePackageUpgrades.sort((a, b) => (a.order > b.order) ? 1 : -1);

            this.upgradeavaibilitydone[2] = true;
            this.showTheUpgradeScreen[2] = true;
            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

            this.setTab(Sections.Upgrades);

            this.busyService.idle();
          }
          else
          {
            this.upgradeavaibilitydone[2] = true;
            this.showTheUpgradeScreen[2] = false;

            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

            this.busyService.idle();
          }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: (response as availabletimes_returndata).messages[0]});
          this.busyService.idle();
        }
      }, error => {
        this.busyService.idle();
      });
    }
    else
    {
      this.upgradeavaibilitydone[2] = true;
    }
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  addMs = (date: Date, ms: number): Date => {
    const result = new Date(date);
    result.setMilliseconds(result.getMilliseconds() + ms);
    return result;
  };

  printConfirmation()
  {
    //this.confHTML = "https://email.wannabook.online/print/" + this.VenueID + "/" + this.NewBooking.bookingId;
    this.showPrintConfirmations = true;
    this.http.get(bmxurl + "print/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.confHTML = (response as conf_returndata).data.toString();
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Payment Types.'});
    })

  }

  switchToToday(){
    this.SelectedDate = new Date();
    this.doneDate();
  }

  switchTomorrow(){
    let tomorrow = new Date();
    tomorrow.setDate(new Date().getDate() + 1);

    this.SelectedDate = tomorrow;
    this.doneDate();
  }

  switchToSaturday()
  {
    let saturday = new Date();
    let overflow = 0;

    while(saturday.getDay() != 6 && overflow <= 7)
    {
      saturday.setDate(saturday.getDate() + 1);
      overflow ++;
    }

    this.SelectedDate = saturday;
    this.doneDate();
  }

  switchToSunday()
  {
    let sunday = new Date();
    let overflow = 0;

    while(sunday.getDay() != 0 && overflow <= 7)
    {
      sunday.setDate(sunday.getDate() + 1);
      overflow ++;
    }

    this.SelectedDate = sunday;
    this.doneDate();
  }
}

enum Sections {
  Date = 0,
  Package = 1,
  Admissions = 2,
  Partyroom = 3,
  Time = 4,
  Customer = 5,
  Extras = 6,
  Notes = 7,
  Payment = 8,
  BookingQuestions = 9,
  Upgrades = 10,
  OptionalUpgrades = 11
}


